// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:37:05.011Z
// Property: Scout Landing (ID: 5716675206840320)
// Collections: 19 amenities, 6 floorplans (live), 32 photos, 82 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5716675206840320",
  "property_external_id": "4975491",
  "property_zillow_url": "https://www.zillow.com/b/the-harrison-murfreesboro-tn-5Xhxjm/",
  "property_apartments_url": "https://www.apartments.com/scout-landing-murfreesboro-tn/5sl28xp",
  "property_google_business_url": "https://www.google.com/maps/place/The+Harrison/@35.7840819,-86.408157,17z/data=!3m1!4b1!4m5!3m4!1s0x8863f9f1d4068b5d:0xabeb250191ce9347!8m2!3d35.7840915!4d-86.4060482",
  "property_linkedin_url": null,
  "property_hubspot_id": "8384315321",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "scout-landing",
  "property_name": "Scout Landing",
  "property_website_url": "https://www.scoutlanding.com/",
  "property_domain": "https://www.scoutlanding.com/",
  "property_address": "261 Veterans Pkwy",
  "property_full_address": "261 Veterans Pkwy, Murfreesboro, TN 37128",
  "property_address_1": "261 Veterans Pkwy",
  "property_address_2": null,
  "property_address_city": "Murfreesboro",
  "property_address_state": "TN",
  "property_address_zip_full": "37128-6441",
  "property_address_zip": "37128",
  "property_address_country": "US",
  "property_address_county": "Rutherford County",
  "property_neighborhood_address": "Outer Rutherford County",
  "property_address_latitude": "35.7836707",
  "property_address_longitude": "-86.4057581",
  "property_email": "scout@alapts.com",
  "property_phone": "(615) 848-1022",
  "property_call_tracking_phone": "629-299-2303",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>House-like comfort meets polished apartment style at Scout Landing.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with standout finishes like granite countertops, stainless steel appliances, hardwood-style flooring, in-home laundry, and select loft layouts with vaulted ceilings—then <a href=\"/schedule-a-tour\">schedule a tour</a> to find your fit.</p>",
  "property_long_description": "<p><strong>Settle into a Murfreesboro apartment with room to live your way.</strong> At Scout Landing, one-, two-, and three-bedroom floor plans pair house-like comfort with polished details—stainless steel appliances, granite countertops, designer stone backsplash, hardwood-style flooring, custom shelving, in-home laundry, and select loft layouts with vaulted ceilings.</p><p>Step outside your front door to <a href=\"/amenities\">amenities built for everyday ease</a>: a resort-inspired pool, poolside outdoor kitchen, expanded cardio and strength studio, clubhouse Wi-Fi, package lockers, EV charging, controlled access, and a bark park. The setting keeps you connected, too, with quick access to I-24, South Church Street, downtown Murfreesboro, The Avenue’s shopping and dining, Middle Tennessee State University, and Barfield Crescent Park’s trails, disc golf, greenway access, and open-air recreation. Explore <a href=\"/floor-plans\">available layouts</a> and find the space that feels like yours.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019d02f1-e23c-7254-85c6-14192ecaa69d.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living area with a fireplace, kitchen island with bar stools, and a dining area.",
    "public_id": "019d02f1-e23c-7254-85c6-14192ecaa69d",
    "storage_key": "property/5716675206840320/019d02f1-e23c-7254-85c6-14192ecaa69d.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "278",
  "property_year_built": "2001",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.76258992805755",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8875309.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://scoutlanding.loftliving.com/login",
  "property_apply_now_url": "https://8875309.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-7b4f-7058-8cb0-3a8afd5585c3.webp",
  "property_primary_logo_media": {
    "alt_text": "Scout Landing Premier Apartments logo.",
    "public_id": "019e7020-7b4f-7058-8cb0-3a8afd5585c3",
    "storage_key": "property/5716675206840320/019e7020-7b4f-7058-8cb0-3a8afd5585c3.webp",
    "width": 2105,
    "height": 913
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-7931-756d-87d5-497348e6358b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Scout Landing Premier Apartments logo",
    "public_id": "019e7020-7931-756d-87d5-497348e6358b",
    "storage_key": "property/5716675206840320/019e7020-7931-756d-87d5-497348e6358b.webp",
    "width": 2105,
    "height": 913
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-790f-7104-96ed-445baaf3425d.webp",
  "property_icon_media": {
    "alt_text": "The letter S with a star above chevron stripes.",
    "public_id": "019e7020-790f-7104-96ed-445baaf3425d",
    "storage_key": "property/5716675206840320/019e7020-790f-7104-96ed-445baaf3425d.webp",
    "width": 1061,
    "height": 1061
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-790f-7104-96ed-445baaf3425d.webp",
  "property_fav_icon_media": {
    "alt_text": "The letter S with a star above chevron stripes.",
    "public_id": "019e7020-790f-7104-96ed-445baaf3425d",
    "storage_key": "property/5716675206840320/019e7020-790f-7104-96ed-445baaf3425d.webp",
    "width": 1061,
    "height": 1061
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-7b4c-7619-bedb-4f94c130987a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Scout Landing Premier Apartments logo",
    "public_id": "019e7020-7b4c-7619-bedb-4f94c130987a",
    "storage_key": "property/5716675206840320/019e7020-7b4c-7619-bedb-4f94c130987a.webp",
    "width": 2105,
    "height": 913
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-7b85-727c-8641-efb44930edfb.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Scout Landing Premier Apartments logo",
    "public_id": "019e7020-7b85-727c-8641-efb44930edfb",
    "storage_key": "property/5716675206840320/019e7020-7b85-727c-8641-efb44930edfb.webp",
    "width": 2105,
    "height": 913
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#1b448b",
  "property_secondary_color": "#b9cedd",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#5b4a42",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "529 - 1340",
  "property_sqft_min": "529",
  "property_sqft_max": "1340",
  "property_price_range": "1180.66 - 1895",
  "property_price_min": "1180.66",
  "property_price_max": "1895",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/scoutlandingapts",
  "property_instagram_url": "https://www.instagram.com/scoutlanding",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJXYsG1PH5Y4gRR5POkQEl66s",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/scout-landing-murfreesboro",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease meets resort-style recharge.</strong> At Scout Landing, streamlined perks like Parcel Pending lockers, 24/7 online resident services, and door-to-door trash pickup keep routines moving, while a newly expanded cardio and strength studio, clubhouse Wi-Fi, and pool with outdoor kitchen set the scene for downtime.</p><p>Inside, stainless steel appliances, designer stone backsplash, hardwood-style flooring, custom closet shelving, and in-home laundry bring polished function home, with select layouts adding vaulted ceilings, fireplaces, patios, or balconies.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Scout Landing.</strong> Explore one-, two-, and three-bedroom apartments in Murfreesboro with open living areas, polished kitchens, and select private outdoor spaces. Stainless steel appliances, granite countertops, hardwood-style flooring, custom closet shelving, and in-home washers and dryers add everyday ease, while select layouts offer vaulted ceilings, fireplaces, island kitchens, loft-style character, balconies, or patios.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of Scout Landing.</strong> Preview bright kitchens with white cabinetry, granite countertops, and stainless steel appliances, plus airy living spaces with fireplaces, high ceilings, and loft-style details. The gallery also captures calm modern finishes, a resort-inspired pool, fitness studio, polished clubhouse lounge, bark park, blue front doors, and landscaped green space—all setting the scene for life at Scout Landing.</p>",
  "property_home_neighborhood_blurb": "<p><strong>South Murfreesboro, within easy reach.</strong> Scout Landing puts Veterans Parkway, South Church Street, and everyday errands close to home, with Sir Pizza, Vui’s Kitchen, Taziki’s, and Westlawn grocery stops nearby. Barfield Crescent Park adds wooded trails, greenway access, disc golf, and open-air recreation just down the road, while Downtown Murfreesboro brings the Public Square, local dining, shops, and year-round energy into the mix.</p>",
  "property_home_reviews_blurb": "<p><strong>Everyday comfort, in residents’ own words.</strong> Scout Landing reviews call out the details that make home feel easy: peaceful apartment interiors, attentive service, responsive management, and grounds that stay well cared for. See why reviewers appreciate the quiet atmosphere, helpful follow-through, and layouts designed for comfortable daily living.</p>",
  "property_neighborhood_blurb": "<p><strong>South Murfreesboro, mapped to your day.</strong> From Scout Landing, you’re positioned near the Veterans Parkway and South Church Street corridor, where everyday stops, local bites, and cross-town routes are easy to reach. Pick up pizza close by at Sir Pizza, head west on Veterans for fast-casual favorites like Vui’s Kitchen and Taziki’s, or make a grocery run toward Westlawn before coming home.</p><p>When you want more room to roam, Barfield Crescent Park brings greenway access, wooded trails, disc golf, and wide-open recreation just down the road. Downtown Murfreesboro adds a different pace, with the historic Public Square, local restaurants, boutiques, and year-round community energy. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Scout Landing connects you to the best of the area.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, without the extra effort.</strong> At Scout Landing, your day can move from package pickup to a workout to poolside downtime without leaving the community. Parcel Pending lockers, 24/7 online resident services, and door-to-door trash pickup help streamline the routine, while the newly expanded cardio and strength studio, clubhouse Wi-Fi, and resort-inspired pool with an outdoor kitchen add more ways to recharge.</p><p>Inside your Murfreesboro apartment, polished finishes keep the experience just as practical: stainless steel appliances, designer stone backsplash, hardwood-style flooring, custom closet shelving, and in-home laundry bring everyday function into focus. Select homes add loft-style layouts, vaulted ceilings, fireplaces, patios, or balconies. Have a pet? The on-site bark park adds another reason to explore the <a href=\"/pet-policy\">pet-friendly amenities</a>. See the spaces in action in the <a href=\"/gallery\">photo gallery</a>, then choose the features that fit how you live.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Scout Landing yours?</strong> Start your application online for a one-, two-, or three-bedroom apartment with house-like comfort, polished finishes, and everyday ease—granite countertops, stainless steel appliances, in-home laundry, and community spaces designed to simplify your routine.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong><br>Contact the Scout Landing leasing team to learn more about one-, two-, and three-bedroom apartments, polished in-home finishes, everyday community amenities, or directions to our Murfreesboro location near I-24.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Scout Landing?</strong> Start here for quick answers on floor plans, leasing, amenities, and everyday living in our Murfreesboro apartments. From polished in-home finishes to community conveniences, this FAQ is here to help—and the leasing team is happy to answer anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that matches how you use your space.</strong> Scout Landing offers one-, two-, and three-bedroom apartments in Murfreesboro, with options ranging from streamlined, easy-to-maintain homes to larger layouts with room to spread out. Browse current availability, compare pricing, and picture everyday routines in spaces designed with open living areas, well-appointed kitchens, and private outdoor space in select homes.</p><p>Inside, details like <a href=\"/amenities\">stainless steel appliances</a>, granite countertops, designer stone backsplash, hardwood-style flooring, custom closet shelving, and in-home washer and dryers bring function and polish together. Select floor plans add loft-style character, vaulted ceilings, fireplaces, island kitchens, pantries, balconies, or patios. When you find a favorite, <a href=\"/schedule-a-tour\">schedule a tour</a> to see the flow in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces that set the tone.</strong> Browse the Scout Landing photo gallery for a closer look at bright kitchens with white cabinetry, granite countertops, and stainless steel appliances; living areas with fireplaces, high ceilings, and loft-style moments; and bedrooms and baths finished in calm, modern neutrals. Outside, picture sunny afternoons by the <a href=\"/amenities\">resort-inspired pool</a>, workouts in the cardio and strength studio, or a quick stop in the polished clubhouse lounge before the day begins. You’ll also catch glimpses of the bark park, walk-up apartment buildings, blue front doors, and landscaped green space. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Scout Landing in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Scout Landing from every angle.</strong> Use the interactive map to browse <a href=\"/floor-plans\">available apartments</a>, see how the community connects to Murfreesboro shopping, dining, parks, and commuter routes, and find the location that fits your day-to-day.</p>",
  "property_pets_blurb": "<p><strong>Your pet’s routine gets its own set of perks.</strong> At Scout Landing, cats and dogs have room to feel at home, from comfortable apartment layouts to outdoor spaces made for quick breaks and longer strolls. The on-site bark park adds an easy place for dogs to stretch their legs close to home, while walking and biking trails, courtyards, picnic areas, and patios or balconies in select homes make fresh-air time part of the everyday rhythm.</p><p>When you need to stock up, book care, or find a change of scenery, Murfreesboro offers nearby pet services and city bark parks within reach. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Scout Landing fits life with your cat or dog.</p>",
  "property_referafriend_blurb": "<p><strong>Share the space you love.</strong> Invite a friend to Scout Landing, where roomy one-, two-, and three-bedroom apartments pair house-like comfort with polished finishes like granite countertops, stainless steel appliances, hardwood-style flooring, and in-home laundry—plus everyday perks just outside the door.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Scout Landing.</strong><br>Pay rent, submit maintenance requests, and manage your account in a few easy clicks—so you can get back to enjoying the polished comfort, everyday ease, and room-to-live design that make your Murfreesboro apartment feel like yours.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, grounded in everyday living.</strong> Reviews for Scout Landing point to the details you notice once you’re home: responsive management, friendly service, well-kept grounds, and layouts that feel easy to enjoy.</p><p>Residents highlight the calm atmosphere most of all, with one reviewer calling it “really peaceful” and noting how quiet the apartment feels inside. Others mention quick follow-through from the team and thoughtful attention when needs come up. Browse the reviews below to see what living at Scout Landing is like from the people who know it firsthand.</p>",
  "property_created_at": "1752256598645",
  "property_scheduletour_blurb": "<p><strong>See Scout Landing up close.</strong> Tour one-, two-, and three-bedroom apartments with house-like comfort, polished finishes, in-home laundry, and select loft layouts with vaulted ceilings. Then picture daily routines around the resort-inspired pool, fitness studio, clubhouse Wi-Fi, and bark park. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks for reaching out to Scout Landing.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture a Murfreesboro apartment with house-like comfort, polished finishes, flexible floor plans, and everyday conveniences that make it easy to settle in and live your way.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Scout Landing before you arrive.</strong> These virtual tours let you move room by room through the spaces that matter most: community views, the Clubhouse, the Fitness Center/Resident Lounge, the Cardio Room, and the two-bedroom B2 apartment tour. Step inside the B2 to see the flow from the bright living area and fireplace to the polished kitchen, then look upstairs at the loft-style space with vaulted-ceiling character. Community tours bring the clubhouse details into focus, from comfortable lounge seating and a fireplace accent wall to workout areas with cardio equipment and natural light. When you are ready to compare the virtual view with the real thing, explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> in Murfreesboro.</p>",
  "property_copyright": "2025 All Rights Reserved. Scout Landing",
  "property_seo_title_home": "Scout Landing | Apartments in Murfreesboro, TN",
  "property_seo_description_home": "Experience modern living at Scout Landing in Murfreesboro, TN. Enjoy spacious floor plans, luxury amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Murfreesboro, TN",
  "property_seo_description_floorplans": "Discover your ideal home at Scout Landing in Murfreesboro, TN! Explore our diverse selection of spacious floor plans, including one, two, and three-bedroom apartments. With a variety of layouts to suit your lifestyle, you're sure to find the perfect fit. Browse our available apartment homes today and start your journey to comfortable living!",
  "property_seo_title_amenities": "Amenities | Murfreesboro, TN Apartments for Rent",
  "property_seo_description_amenities": "Discover exceptional living at Scout Landing in Murfreesboro, TN! Choose from our stylish one, two, and three-bedroom apartments featuring modern amenities like smart locks, a fitness center, and a refreshing pool. Enjoy resort-style perks, including a dog park, outdoor kitchen, and a yoga studio. Plus, benefit from conveniences such as online resident services and LUXER package lockers. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Murfreesboro, TN",
  "property_seo_description_gallery": "Discover your perfect home at Scout Landing in Murfreesboro, TN! Explore our stunning photo gallery showcasing spacious floor plans, including one, two, and three-bedroom apartments. Experience premier amenities like a state-of-the-art fitness center, luxurious dog park, and inviting outdoor kitchen. Enjoy smart locks, walk-in closets, and modern kitchen appliances in your stylish apartment with tall ceilings and vibrant tile backsplashes. Picture yourself living here – the ultimate blend of comfort and convenience awaits you at Scout Landing!",
  "property_seo_title_virtualtours": "Virtual Tours | Scout Landing Apartments",
  "property_seo_description_virtualtours": "Explore your dream home at Scout Landing in Murfreesboro, TN! Discover our spacious one, two, and three-bedroom floor plans designed for comfort and style. Take a virtual tour of our vibrant community today and see why Scout Landing is the perfect place for you. Don’t miss out—schedule your visit now!",
  "property_seo_title_interactivemap": "Interactive Map | Scout Landing Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Scout Landing in Murfreesboro, TN! Explore spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy top-notch amenities like a dog park, fitness center, and outdoor kitchen, along with smart locks and luxurious finishes. Use our interactive community map to find available apartments, view pricing, and select your new home! Experience the vibrant lifestyle at Scout Landing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Murfreesboro, TN",
  "property_seo_description_neighborhood": "Discover Scout Landing in Murfreesboro, TN! Explore our diverse floor plans, including one, two, and three-bedroom apartments, and immerse yourself in the vibrant neighborhood. See what's around our community and uncover local favorites and nearby points of interest. Your perfect new home awaits at Scout Landing!",
  "property_seo_title_contact": "Contact Us | Scout Landing",
  "property_seo_description_contact": "Discover your ideal home at Scout Landing in Murfreesboro, TN! Our community offers thoughtfully designed floor plans featuring one, two, and three-bedroom apartments to suit your lifestyle. Have questions? Contact our leasing team today for more information and to schedule a tour. Experience comfortable living at Scout Landing!",
  "property_seo_title_faqs": "FAQs | Apartments in Murfreesboro, TN",
  "property_seo_description_faqs": "Discover Scout Landing in Murfreesboro, TN! Explore our diverse floor plans, including one, two, and three-bedroom apartments, equipped with modern amenities like smart locks, a fitness center, and a dog park. Have questions? Browse our FAQs page for all the answers about living in our vibrant community, featuring an outdoor kitchen, pool, and online resident services. Join us at Scout Landing where comfort meets convenience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Murfreesboro, TN",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Scout Landing in Murfreesboro, TN! With spacious one, two, and three-bedroom floor plans, our community offers exceptional amenities like a state-of-the-art fitness center, dog park, outdoor kitchen, and a refreshing pool. Enjoy the convenience of SMART locks, LUXER Package Locker system, and online resident services. Don't just take our word for it—see what our residents have to say about living at Scout Landing! Your perfect apartment awaits.",
  "property_seo_title_applynow": "Apply Now | Apartments in Murfreesboro, TN",
  "property_seo_description_applynow": "Discover your dream apartment at Scout Landing in Murfreesboro, TN! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and style. Enjoy top-notch amenities, including a fitness center, outdoor kitchen, dog park, and a sparkling pool. With smart locks, walk-in closets, and stylish finishes, your perfect lifestyle awaits. Experience convenience with online resident services and LUXER package lockers. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Scout Landing",
  "property_seo_description_residentaccess": "\"Welcome to Scout Landing in Murfreesboro, TN! Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected with your community. Experience convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Scout Landing",
  "property_seo_description_referafriend": "Discover the perfect neighborhood at Scout Landing in Murfreesboro, TN! Great friends make great neighbors—refer a friend to our vibrant community today and enjoy exclusive rewards. Join us at Scout Landing, where connections flourish and comfort awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | Scout Landing",
  "property_seo_description_scheduletour": "Discover your new home at Scout Landing in Murfreesboro, TN! Experience modern living with exceptional amenities in a welcoming community. Don’t miss out—schedule a tour today and explore everything Scout Landing has to offer!",
  "property_seo_title_privacy": "Privacy Policy | Scout Landing",
  "property_seo_description_privacy": "\"At Scout Landing in Murfreesboro, TN, your privacy matters. Discover how we protect your personal information and ensure a safe living experience. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Scout Landing",
  "property_seo_description_accessibility": "\"Discover Scout Landing in Murfreesboro, TN, where we prioritize digital inclusion for all. Explore our Accessibility Statement to learn how we ensure an accessible living experience. Join our community today and experience a seamless online journey!\"",
  "property_seo_title_sitemap": "Sitemap | Scout Landing",
  "property_seo_description_sitemap": "Discover the layout and offerings of Scout Landing in Murfreesboro, TN! Explore our comprehensive sitemap to easily navigate our vibrant apartment community and find the perfect home for you. View our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | Scout Landing",
  "property_seo_description_thankyou": "Thank you for reaching out to Scout Landing in Murfreesboro, TN! Your submission has been received. A member of our friendly team will be in touch shortly to assist you with your apartment search. We’re excited to help you discover your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320229",
  "amenities": [
    {
      "id": "custom_e1b9c544-343b-4ce0-beaf-9b6f4fc6acbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2100653d-36f0-44d0-878c-ae319851f44c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1f934e3-e11d-4db9-9623-c19a9b98e324",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c49d8fa1-eed8-4362-98df-62fe450c07a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2 Faux Wood Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b58fe05a-a259-4a79-9cd8-673325712130",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56ce14a8-09a3-4fde-ba4a-9ffed01bac85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0d2ec4f-425e-4b9e-a8b0-6eb33122888b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Newly Expanded Fitness Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c536409e-d525-4019-90a9-17c9dcb031c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_583df354-3e03-4fd1-8c2f-3da851833e63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a1dfd82-1a84-4034-9d18-b9d6ae90b7c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000657",
      "title": "Loft Apartments",
      "amount": "0.0000",
      "description": "Loft Style Apartments Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86b84847-b2cd-47ad-978f-8b41f8be9236",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb8755dd-f496-4b52-890c-48801ddf1c31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Poolside Outdoor Kitchen Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b3eb96e-7189-4b22-b4d0-09f8e7af1fe2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21a37c25-4329-49e6-a7bc-68f8f3907dc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e82872f-7c5d-4354-90d1-780d2cdf4a2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Designer Stone Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1e502b8-62db-4c3d-986a-2badf3789756",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1c3033d-14d8-4df8-af04-db44624b441c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Closets w/Custom Shelving",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2d0a44f-e8a1-4ae3-971a-6945a403a5ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000001409",
      "title": "WiFi at Pool & Clubhouse",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a402c451-6278-44cc-b7d5-3876ef8129c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "external_id": "P000002466",
      "title": "Yoga/Flex Studio",
      "amount": "0.0000",
      "description": "Cardio & Strength Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4381c098-831c-4846-a4cf-d73e184d43f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-2ab0-7702-b9a7-ad1ad81da693.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and a modern kitchen bar with stools.",
        "public_id": "019e89af-2ab0-7702-b9a7-ad1ad81da693",
        "storage_key": "property/5716675206840320/019e89af-2ab0-7702-b9a7-ad1ad81da693.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living area, featuring a cozy fireplace and a convenient kitchen bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace and a modern kitchen bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd69b109-4a60-4844-8075-fdba1b38bd37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-2a8f-70ee-8bcb-26e14e473256.webp",
      "image_media": {
        "alt_text": "Playground with swings, a seesaw, and a slide.",
        "public_id": "019e89af-2a8f-70ee-8bcb-26e14e473256",
        "storage_key": "property/5716675206840320/019e89af-2a8f-70ee-8bcb-26e14e473256.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring swings, a seesaw, and a slide.",
      "link": "",
      "alt_text": "Playground with swings, a seesaw, and a slide.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8e4a3f1-0bd6-4489-90d3-739b3ceea72c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-2672-77d0-9993-b6bd6aa26ced.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool and clubhouse exterior with lounge chairs and tables.",
        "public_id": "019e89af-2672-77d0-9993-b6bd6aa26ced",
        "storage_key": "property/5716675206840320/019e89af-2672-77d0-9993-b6bd6aa26ced.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax on the sun-drenched deck. The adjacent clubhouse offers a perfect spot for gatherings or a quiet escape.",
      "link": "",
      "alt_text": "Luxury swimming pool and clubhouse exterior with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1e698dc-8dad-4391-a394-5a4eda114894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1e3d-750a-8873-c6741f98d1a9.webp",
      "image_media": {
        "alt_text": "Dining area with blue chairs and a fireplace, overlooking a pool area.",
        "public_id": "019e89af-1e3d-750a-8873-c6741f98d1a9",
        "storage_key": "property/5716675206840320/019e89af-1e3d-750a-8873-c6741f98d1a9.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy a meal in the elegant dining area, featuring comfortable blue chairs and a decorative fireplace, with views of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Dining area with blue chairs and a fireplace, overlooking a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_240007cb-e1e5-46f2-8fd6-46dd55addcfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-20e8-7292-af48-3411e054efcc.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, built-in desk with chair, and ceiling fan.",
        "public_id": "019e89af-20e8-7292-af48-3411e054efcc",
        "storage_key": "property/5716675206840320/019e89af-20e8-7292-af48-3411e054efcc.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A stylish living room featuring a comfortable white sofa, a dedicated workspace with a built-in desk, and a modern ceiling fan, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Living room with white sofa, built-in desk with chair, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24bd3246-529d-4d3d-922f-33fcf910b4f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1de9-7689-b447-c3dcb2e32991.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue doors and gray siding.",
        "public_id": "019e89af-1de9-7689-b447-c3dcb2e32991",
        "storage_key": "property/5716675206840320/019e89af-1de9-7689-b447-c3dcb2e32991.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, featuring charming blue doors and classic gray siding.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue doors and gray siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45fb3796-f0a4-4213-950f-9b961864034b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1e3f-75cd-972c-b5b4f1fb6c96.webp",
      "image_media": {
        "alt_text": "King size bed in a bedroom with blue walls and modern decor.",
        "public_id": "019e89af-1e3f-75cd-972c-b5b4f1fb6c96",
        "storage_key": "property/5716675206840320/019e89af-1e3f-75cd-972c-b5b4f1fb6c96.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, plush bedding, and tasteful decor with a calming blue accent wall. This room offers a serene retreat.",
      "link": "",
      "alt_text": "King size bed in a bedroom with blue walls and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_720630a9-4785-4a19-87f5-3e952d77c2a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1f1d-7666-b3bf-68559b8ecdda.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with blue doors and grey roofs.",
        "public_id": "019e89af-1f1d-7666-b3bf-68559b8ecdda",
        "storage_key": "property/5716675206840320/019e89af-1f1d-7666-b3bf-68559b8ecdda.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Beautifully maintained apartment exteriors with welcoming blue doors and classic grey roofing, set against a backdrop of lush green landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with blue doors and grey roofs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23aef25c-8145-4ec2-9c87-ebaf8bfb5311",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1baf-71c3-a538-7e3b3e63bb1e.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and mirrors.",
        "public_id": "019e89af-1baf-71c3-a538-7e3b3e63bb1e",
        "storage_key": "property/5716675206840320/019e89af-1baf-71c3-a538-7e3b3e63bb1e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with a variety of cardio and weight training machines for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5983202e-f8cb-4f26-96be-552f289af5d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1ca1-76c7-b76c-4b49d2506df4.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, shower, vanity, toilet, and glass shower doors.",
        "public_id": "019e89af-1ca1-76c7-b76c-4b49d2506df4",
        "storage_key": "property/5716675206840320/019e89af-1ca1-76c7-b76c-4b49d2506df4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Sparkling clean bathroom featuring a bathtub and shower combo with a stylish curtain, a granite-top vanity with decorative accents, and a separate glass-enclosed shower area.",
      "link": "",
      "alt_text": "Bathroom with bathtub, shower, vanity, toilet, and glass shower doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7020304f-7cbe-4136-92a7-8f7021b55ee4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1e21-7718-97a4-e0f3391bf8c2.webp",
      "image_media": {
        "alt_text": "Elegant community lounge area with fireplace, seating, and large windows overlooking the exterior.",
        "public_id": "019e89af-1e21-7718-97a4-e0f3391bf8c2",
        "storage_key": "property/5716675206840320/019e89af-1e21-7718-97a4-e0f3391bf8c2.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Experience the inviting atmosphere of our community lounge, featuring a cozy fireplace, comfortable seating, and ample natural light. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Elegant community lounge area with fireplace, seating, and large windows overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_afbebfb2-98d0-49b5-a706-07589191c9d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1d5c-706d-842b-eaaa83ca39e8.webp",
      "image_media": {
        "alt_text": "Open concept dining and kitchen area with high ceilings, featuring a breakfast bar, modern appliances, and artistic wall decor.",
        "public_id": "019e89af-1d5c-706d-842b-eaaa83ca39e8",
        "storage_key": "property/5716675206840320/019e89af-1d5c-706d-842b-eaaa83ca39e8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Experience spacious living in our open-concept dining and kitchen areas, perfect for entertaining. Enjoy high ceilings, a stylish breakfast bar, and modern appliances that complement the elegant interior design.",
      "link": "",
      "alt_text": "Open concept dining and kitchen area with high ceilings, featuring a breakfast bar, modern appliances, and artistic wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e59ad40-f1a1-4e01-8d97-a5d6818ff2f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1816-752a-997c-517a29d27e7d.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dresser, and a ceiling fan.",
        "public_id": "019e89af-1816-752a-997c-517a29d27e7d",
        "storage_key": "property/5716675206840320/019e89af-1816-752a-997c-517a29d27e7d.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage, and stylish decor.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c90a0d8-894c-4cb5-9ba8-41d0af673e5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0d8b-75ac-b5e6-51a6dcf2185a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor bar area in front of the apartment buildings.",
        "public_id": "019e89af-0d8b-75ac-b5e6-51a6dcf2185a",
        "storage_key": "property/5716675206840320/019e89af-0d8b-75ac-b5e6-51a6dcf2185a.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and an outdoor bar area for ultimate relaxation. Our community amenities provide the perfect setting for leisure and entertainment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor bar area in front of the apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c0a5468-9415-4d6b-af29-4faad616673c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0feb-7025-8207-eb337bbaa231.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with high ceilings, fireplace, and stairs.",
        "public_id": "019e89af-0feb-7025-8207-eb337bbaa231",
        "storage_key": "property/5716675206840320/019e89af-0feb-7025-8207-eb337bbaa231.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, modern kitchen with island seating, and a dining nook. High ceilings and an open layout create an inviting atmosphere.",
      "link": "",
      "alt_text": "Living room and kitchen area with high ceilings, fireplace, and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7daf100f-e594-436f-8134-69358be0f2e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0f0a-76bd-8764-61dc7dcb19d1.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceilings, fireplace, and a couch.",
        "public_id": "019e89af-0f0a-76bd-8764-61dc7dcb19d1",
        "storage_key": "property/5716675206840320/019e89af-0f0a-76bd-8764-61dc7dcb19d1.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious living room featuring vaulted ceilings, a cozy fireplace, a comfortable sofa, and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Living room with vaulted ceilings, fireplace, and a couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae786952-d754-45f9-99a4-f030f3338f87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0d76-77ad-9d95-573577999276.webp",
      "image_media": {
        "alt_text": "Living room and dining area with stairs",
        "public_id": "019e89af-0d76-77ad-9d95-573577999276",
        "storage_key": "property/5716675206840320/019e89af-0d76-77ad-9d95-573577999276.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a plush sofa, accent chairs, and a contemporary dining set, complemented by a striking staircase.",
      "link": "",
      "alt_text": "Living room and dining area with stairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7578ec4c-c560-4cb6-92a4-599361028d81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-1013-7060-84ac-bfb3e190733d.webp",
      "image_media": {
        "alt_text": "Spacious leasing office with a large reception desk, seating areas, and large windows.",
        "public_id": "019e89af-1013-7060-84ac-bfb3e190733d",
        "storage_key": "property/5716675206840320/019e89af-1013-7060-84ac-bfb3e190733d.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a stylish reception desk and comfortable seating areas, perfect for discussing your new home.",
      "link": "",
      "alt_text": "Spacious leasing office with a large reception desk, seating areas, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7761d7aa-d133-48a7-90c7-908d0dee80b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0f66-75ff-94c5-e2083b2d5461.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, a large table, and a TV.",
        "public_id": "019e89af-0f66-75ff-94c5-e2083b2d5461",
        "storage_key": "property/5716675206840320/019e89af-0f66-75ff-94c5-e2083b2d5461.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring ample seating, a communal table, and entertainment options.",
      "link": "",
      "alt_text": "Modern community lounge area with comfortable seating, a large table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c54924a3-3337-43a0-b87a-311579a66ac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0f37-7032-add5-2ddec38ce001.webp",
      "image_media": {
        "alt_text": "Bathroom with a granite vanity, mirror, bathtub with a yellow shower curtain, and a walk-in closet.",
        "public_id": "019e89af-0f37-7032-add5-2ddec38ce001",
        "storage_key": "property/5716675206840320/019e89af-0f37-7032-add5-2ddec38ce001.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite-top vanity with a large mirror, a bathtub with a decorative yellow shower curtain, and a spacious walk-in closet with shelving.",
      "link": "",
      "alt_text": "Bathroom with a granite vanity, mirror, bathtub with a yellow shower curtain, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f185250-3f62-4b2e-a115-1c05b54c7b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0dd3-703e-9094-1c812f5cc69e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019e89af-0dd3-703e-9094-1c812f5cc69e",
        "storage_key": "property/5716675206840320/019e89af-0dd3-703e-9094-1c812f5cc69e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a double sink, dishwasher, refrigerator, microwave, and a stovetop, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2552ef7d-7696-44bb-99fe-2c4e818926b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0dcb-76bd-905d-dbf39199f4ec.webp",
      "image_media": {
        "alt_text": "Gym with exercise bikes, weight benches, and medicine balls.",
        "public_id": "019e89af-0dcb-76bd-905d-dbf39199f4ec",
        "storage_key": "property/5716675206840320/019e89af-0dcb-76bd-905d-dbf39199f4ec.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center featuring cardio machines, free weights, and functional training equipment.",
      "link": "",
      "alt_text": "Gym with exercise bikes, weight benches, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9da6cca-ad5e-428d-977d-342299b998d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0083-763a-b6a1-f82c616c8f48.webp",
      "image_media": {
        "alt_text": "Loft living area with white sofa, ceiling fan, and vaulted ceiling.",
        "public_id": "019e89af-0083-763a-b6a1-f82c616c8f48",
        "storage_key": "property/5716675206840320/019e89af-0083-763a-b6a1-f82c616c8f48.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious loft living area featuring a comfortable white sofa, vaulted ceilings, and a ceiling fan, perfect for relaxation or entertaining.",
      "link": "",
      "alt_text": "Loft living area with white sofa, ceiling fan, and vaulted ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dee49c75-6c6f-4ee9-832e-55d8ff13552c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-00fc-772d-8b8f-66e3ba2e6bcb.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and a large glass garage door overlooking the pool area.",
        "public_id": "019e89af-00fc-772d-8b8f-66e3ba2e6bcb",
        "storage_key": "property/5716675206840320/019e89af-00fc-772d-8b8f-66e3ba2e6bcb.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and a spacious workout area. Enjoy a refreshing dip in the pool after your workout.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and a large glass garage door overlooking the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_091ac830-6fc8-4916-89a8-0aa41e3458ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-008a-73b8-9450-3ddd0e897ab6.webp",
      "image_media": {
        "alt_text": "Spacious leasing office with a desk, seating area, and fireplace.",
        "public_id": "019e89af-008a-73b8-9450-3ddd0e897ab6",
        "storage_key": "property/5716675206840320/019e89af-008a-73b8-9450-3ddd0e897ab6.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Welcome to our beautifully designed leasing office, featuring a modern desk, comfortable seating, and a cozy fireplace. Experience the inviting atmosphere of our community.",
      "link": "",
      "alt_text": "Spacious leasing office with a desk, seating area, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5d3f2bd-e74f-483a-abac-94a22fa4c753",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-015b-759d-a219-5bc63656b0c0.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops and bar seating.",
        "public_id": "019e89af-015b-759d-a219-5bc63656b0c0",
        "storage_key": "property/5716675206840320/019e89af-015b-759d-a219-5bc63656b0c0.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops, white cabinets, stainless steel appliances, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Kitchen with granite countertops and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99e7fcfe-65d3-48ad-bdf2-3991211ff572",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-00a1-72d3-8ea9-3cfb7d1fa97b.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, decorative pillows, and a ceiling fan.",
        "public_id": "019e89af-00a1-72d3-8ea9-3cfb7d1fa97b",
        "storage_key": "property/5716675206840320/019e89af-00a1-72d3-8ea9-3cfb7d1fa97b.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious and beautifully appointed bedroom, featuring a comfortable queen-size bed and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a large bed, decorative pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da2f88e0-3ae5-40f5-8d0b-8ec760d3e751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89ae-ffb3-7465-8b94-b4488d7f7d84.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with a walkway and blooming tree.",
        "public_id": "019e89ae-ffb3-7465-8b94-b4488d7f7d84",
        "storage_key": "property/5716675206840320/019e89ae-ffb3-7465-8b94-b4488d7f7d84.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Beautifully maintained townhomes with a charming walkway and vibrant landscaping, offering a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of townhomes with a walkway and blooming tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b48706d8-e4a9-49e7-b116-bf6528a85271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-012e-726c-8017-b20a65b2d7e2.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, fireplace, and large windows.",
        "public_id": "019e89af-012e-726c-8017-b20a65b2d7e2",
        "storage_key": "property/5716675206840320/019e89af-012e-726c-8017-b20a65b2d7e2.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living room with a fireplace, comfortable sectional sofa, and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8553cbc3-6bfb-4b57-a6b8-ea08426dacfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89ae-ffc9-765b-9528-77b3b94ca9d5.webp",
      "image_media": {
        "alt_text": "Dog park area with a bench, fire hydrant, and agility equipment.",
        "public_id": "019e89ae-ffc9-765b-9528-77b3b94ca9d5",
        "storage_key": "property/5716675206840320/019e89ae-ffc9-765b-9528-77b3b94ca9d5.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, equipped with agility equipment and waste stations for your furry friends.",
      "link": "",
      "alt_text": "Dog park area with a bench, fire hydrant, and agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61576bda-b9dd-4224-a059-d4486f2f9442",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89af-0099-742c-abcf-0f8cf33ab66f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, vanity, and walk-in shower.",
        "public_id": "019e89af-0099-742c-abcf-0f8cf33ab66f",
        "storage_key": "property/5716675206840320/019e89af-0099-742c-abcf-0f8cf33ab66f.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a large vanity with a granite countertop, a walk-in shower, and elegant finishes.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop, vanity, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d946a321-8da4-46c2-8fe1-4f054cf75447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e89ae-ff77-7182-8d00-c54ed0eeb8fc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
        "public_id": "019e89ae-ff77-7182-8d00-c54ed0eeb8fc",
        "storage_key": "property/5716675206840320/019e89ae-ff77-7182-8d00-c54ed0eeb8fc.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and lush surrounding trees for a perfect oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_8a245050697a57b724334cd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Sir Pizza-Veterans Parkway",
      "poi_type": "Restaurants",
      "poi_address": "110 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Longtime pizzeria chain serving pies, pasta, sandwiches & wings in a casual atmosphere.",
      "poi_long_description": "Longtime pizzeria chain serving pies, pasta, sandwiches & wings in a casual atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-21b9-7599-8a0a-1d0a745daadd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-21b9-7599-8a0a-1d0a745daadd",
        "storage_key": "property/5716675206840320/019f14fd-21b9-7599-8a0a-1d0a745daadd.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.sirpizzatn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17752660643366800540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sir-pizza-veterans-parkway",
      "poi_latitude": "35.7863489",
      "poi_longitude": "-86.401716",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 615-617-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDROwl-35Y4gRnIzvKcweXvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8c7b0af972944289cc378ad5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Vui's Kitchen - Murfreesboro",
      "poi_type": "Restaurants",
      "poi_address": "4310 Veterans Pkwy Suite B, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-23b2-76ea-9ee1-d258a215bb8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-23b2-76ea-9ee1-d258a215bb8d",
        "storage_key": "property/5716675206840320/019f14fd-23b2-76ea-9ee1-d258a215bb8d.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.vuiskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12878090215073934683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vuis-kitchen---murfreesboro",
      "poi_latitude": "35.841091",
      "poi_longitude": "-86.492873",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-653-4652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYF-oan3Y4gRW23qztEquLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "ec_836d051f4ba45fc4c0e033b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Taziki's Mediterranean Cafe - Kingdom Crest",
      "poi_type": "Restaurants",
      "poi_address": "4310 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-6fc7-77de-9b73-c9550c9720ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-6fc7-77de-9b73-c9550c9720ef",
        "storage_key": "property/5716675206840320/019f14fd-6fc7-77de-9b73-c9550c9720ef.webp",
        "width": 1280,
        "height": 1085
      },
      "poi_business_url": "https://www.tazikis.com/location/kingdom-crest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6768569313817721135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tazikis-mediterranean-cafe---kingdom-crest",
      "poi_latitude": "35.841091",
      "poi_longitude": "-86.492873",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 629-772-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_ZH0p73Y4gRL_m28-3J7l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_b321ed1f1b55cbefbeb2f759",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "TOKI HOUSE",
      "poi_type": "Restaurants",
      "poi_address": "5241 Veterans Pkwy C12, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Relaxed locale dishing up Japanese specialties like sushi, ramen and poke bowls, plus build-your-own options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-246e-7029-bad9-bf7cfff5a999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-246e-7029-bad9-bf7cfff5a999",
        "storage_key": "property/5716675206840320/019f14fd-246e-7029-bad9-bf7cfff5a999.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tokihousemurfreesboro.kwickmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5909638343350540015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toki-house",
      "poi_latitude": "35.8607275",
      "poi_longitude": "-86.5099731",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-624-8163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUgshbf1Y4gR79ZvPsNAA1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "ec_445e809b0bd54fa1195e5227",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-2854-75b2-bb0c-b7a422a044ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-2854-75b2-bb0c-b7a422a044ed",
        "storage_key": "property/5716675206840320/019f14fd-2854-75b2-bb0c-b7a422a044ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1015369",
      "poi_directions_map_url": "https://maps.google.com/?cid=15838291445324650513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.84488",
      "poi_longitude": "-86.49158",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-907-6223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b59-77f8-9266-328a938beb39",
        "storage_key": "property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJrfseBw32Y4gRERivlyfqzNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_a202c97fbd77c2a67007687c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Just Love Coffee Cafe - The Fountains at Gateway",
      "poi_type": "Restaurants",
      "poi_address": "1440 Medical Center Pkwy Suite A, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Cozy cafe serving hearty entrees, sweet waffles, and signature coffees, plus live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-271a-71af-9f55-a1ed7fe3f15c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-271a-71af-9f55-a1ed7fe3f15c",
        "storage_key": "property/5716675206840320/019f14fd-271a-71af-9f55-a1ed7fe3f15c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://justlovecoffeecafe.com/tn-murfreesboro-the-fountains/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16884392278314055824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-love-coffee-cafe---the-fountains-at-gateway",
      "poi_latitude": "35.8607809",
      "poi_longitude": "-86.417598",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-900-2254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b59-77f8-9266-328a938beb39",
        "storage_key": "property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ8Sodxz35Y4gRkPhB3VFpUeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_fdd5c37a9ee140f653560ec7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Miss B's Thai and Sushi",
      "poi_type": "Restaurants",
      "poi_address": "1440 Medical Center Pkwy Ste F, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-2078-7065-9d1d-bb657cd3669c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-2078-7065-9d1d-bb657cd3669c",
        "storage_key": "property/5716675206840320/019f14fd-2078-7065-9d1d-bb657cd3669c.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://missbsthaiandsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13290705943437992918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miss-bs-thai-and-sushi",
      "poi_latitude": "35.8604468",
      "poi_longitude": "-86.41748899999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 629-900-0992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2Qk4xn5Y4gR1mPLbKMScrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_eb47647fe9ff6fd0658dab48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2455 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-28c3-7744-8bcc-cbd5e213b396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-28c3-7744-8bcc-cbd5e213b396",
        "storage_key": "property/5716675206840320/019f14fd-28c3-7744-8bcc-cbd5e213b396.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/tn/murfreesboro?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101628894740981926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "35.8583856",
      "poi_longitude": "-86.4411481",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-956-2560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp34-F973Y4gRpqg_K6noEJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4488ba02a596b30959fa5355",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "2532 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-1f02-764f-b422-22e45c078144.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-1f02-764f-b422-22e45c078144",
        "storage_key": "property/5716675206840320/019f14fd-1f02-764f-b422-22e45c078144.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://firebirdsrestaurants.com/murfreesboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=2044694851412442555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "35.8603072",
      "poi_longitude": "-86.4415633",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-681-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdzm1in3Y4gRuz2CVCI3YBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_8f3b7b5af82e34ee6d9c5a25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "CoreLife Eatery",
      "poi_type": "Restaurants",
      "poi_address": "2330 Medical Center Pkwy E, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Salads, rice noodle bowls, and other healthy meals, with vegan versions available.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-2400-77ef-9894-d3144a5a035d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-2400-77ef-9894-d3144a5a035d",
        "storage_key": "property/5716675206840320/019f14fd-2400-77ef-9894-d3144a5a035d.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.corelifeeatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13661484647079753732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corelife-eatery",
      "poi_latitude": "35.8587778",
      "poi_longitude": "-86.4383622",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-956-0150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ72gFTj3Y4gRBDikpedXl70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9860a92a0016c01cf35df902",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "La Siesta Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1608 NW Broad St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Relaxed eatery featuring Mexican favorites along with some Peruvian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-323f-7260-a168-0b6a023f3964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-323f-7260-a168-0b6a023f3964",
        "storage_key": "property/5716675206840320/019f14fd-323f-7260-a168-0b6a023f3964.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://lasiesta1mexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938816567549600237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-siesta-mexican-restaurant",
      "poi_latitude": "35.8697714",
      "poi_longitude": "-86.41472569999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-890-4606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQZcV_wHZIgR7aHngDgNMt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d34b24c2f4060e9c86589dfc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Five Senses Restaurant, Bar & Catering",
      "poi_type": "Restaurants",
      "poi_address": "1602 W Northfield Blvd #515, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Inventive, seasonal New American cuisine & cocktails offered in vibrant, industrial-chic surrounds.",
      "poi_long_description": "Inventive, seasonal New American cuisine & cocktails offered in vibrant, industrial-chic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-38bc-7559-b719-fd46eab005ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-38bc-7559-b719-fd46eab005ab",
        "storage_key": "property/5716675206840320/019f14fd-38bc-7559-b719-fd46eab005ab.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.fivesensesdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6583107978001035513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-senses-restaurant-bar--catering",
      "poi_latitude": "35.8720221",
      "poi_longitude": "-86.4140984",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-410-7409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYc5avsHZIgR-bDKwtPlW1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_17882e211eef1559f4cf5f32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Bean Loft Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "2136 Middle Tennessee Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Casual hangout for waffles, coffee, smoothies and burritos, plus live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-3b1d-74ab-9bda-a018b390d090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3b1d-74ab-9bda-a018b390d090",
        "storage_key": "property/5716675206840320/019f14fd-3b1d-74ab-9bda-a018b390d090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beanloft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15251061785576769875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bean-loft-coffee-company",
      "poi_latitude": "35.8432172",
      "poi_longitude": "-86.3718474",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-603-7382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b59-77f8-9266-328a938beb39",
        "storage_key": "property/5716675206840320/019f14fd-8b59-77f8-9266-328a938beb39.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJGyQanoAHQS8RU4nW8OOnptM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_34d3af92471d024711bd5ec4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Slick Pig BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1920 E Main St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "BBQ sandwiches, hickory-smoked wings & mac 'n' cheese are served up in a basic, country-style space.",
      "poi_long_description": "BBQ sandwiches, hickory-smoked wings & mac 'n' cheese are served up in a basic, country-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-472e-71bf-833d-571d8823dc6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-472e-71bf-833d-571d8823dc6a",
        "storage_key": "property/5716675206840320/019f14fd-472e-71bf-833d-571d8823dc6a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://slickpigbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4104138556858337827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slick-pig-bbq",
      "poi_latitude": "35.84080000000001",
      "poi_longitude": "-86.35967520000001",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-890-3583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7gnDpX4Y4gRI4qG1kXU9Dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_ea4c7609c62e60eab8bb1c6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Puckett's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "114 N Church St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Casual buffet eatery and grocery store dishing up southern dishes and live music performances.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-40ea-7300-94f3-dc416bfed37d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-40ea-7300-94f3-dc416bfed37d",
        "storage_key": "property/5716675206840320/019f14fd-40ea-7300-94f3-dc416bfed37d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.puckettsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14612373127942536358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pucketts-restaurant",
      "poi_latitude": "35.8464178",
      "poi_longitude": "-86.39100189999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 629-201-6916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-59b0069583de",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-59b0069583de.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cfi4G74Y4gRpnx6sPCTyco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_afa3ca94f160e00ecda81e09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4432 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-3476-703f-b530-e35bcfb8a519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3476-703f-b530-e35bcfb8a519",
        "storage_key": "property/5716675206840320/019f14fd-3476-703f-b530-e35bcfb8a519.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tn/murfreesboro/kroger-tn/026/00565?cid=loc_02600565_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16047282363861062953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "35.844914",
      "poi_longitude": "-86.491687",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-648-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-5e5e968aab5b",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2cpAA32Y4gRKVVUrElms94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b5aadb4e8c8daf592c86f4f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Publix Super Market at Westlawn",
      "poi_type": "Shopping & Retail",
      "poi_address": "5229 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-3fb6-7353-babe-fc92aab4a21c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3fb6-7353-babe-fc92aab4a21c",
        "storage_key": "property/5716675206840320/019f14fd-3fb6-7353-babe-fc92aab4a21c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=10006777212266307741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-westlawn",
      "poi_latitude": "35.860263",
      "poi_longitude": "-86.508894",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-995-7914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-5e5e968aab5b",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cQuGQD1Y4gRnWCbO9s234o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_c1046a6661bdb2812d78700f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2478 New Salem Hwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Clean, quick-serve grocery chain with a friendly staff, as well as home goods and a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-41ab-72fb-93fb-fce276ba008b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-41ab-72fb-93fb-fce276ba008b",
        "storage_key": "property/5716675206840320/019f14fd-41ab-72fb-93fb-fce276ba008b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/5182-murfreesboro-tn/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=780832835925063918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.8141015",
      "poi_longitude": "-86.4471417",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-546-6969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b874-700a-ae7a-5e5e968aab5b",
        "storage_key": "property/5716675206840320/019f14fa-b874-700a-ae7a-5e5e968aab5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2UZqw73Y4gR7jhGxlMT1go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_20f8ba8e34151cb83f525393",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Lopez One Stop Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "106 Veterans Pkwy Ste a, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-3dd6-77f5-8165-d72153fb7df9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3dd6-77f5-8165-d72153fb7df9",
        "storage_key": "property/5716675206840320/019f14fd-3dd6-77f5-8165-d72153fb7df9.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966174170511340775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lopez-one-stop-market",
      "poi_latitude": "35.7865086",
      "poi_longitude": "-86.4012611",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-895-7719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ40wx-6j5Y4gR53TIMQJkEKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_db26556270202f752589d263",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "5265 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-4351-76b2-b9f8-0bb80a811f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4351-76b2-b9f8-0bb80a811f65",
        "storage_key": "property/5716675206840320/019f14fd-4351-76b2-b9f8-0bb80a811f65.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tn/murfreesboro/5265-veterans-pkwy-41962?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216769757779209066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.8620114",
      "poi_longitude": "-86.50866239999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 629-267-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b7f-71e8-8153-2a9d8361b618.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b7f-71e8-8153-2a9d8361b618",
        "storage_key": "property/5716675206840320/019f14fd-8b7f-71e8-8153-2a9d8361b618.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbyimKAD1Y4gRaivSJihnRlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_d98178059cabbe5e1542f0ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "The Avenue Murfreesboro",
      "poi_type": "Shopping & Retail",
      "poi_address": "2615 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_long_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-62b4-768d-b762-b8d6461fe3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-62b4-768d-b762-b8d6461fe3b5",
        "storage_key": "property/5716675206840320/019f14fa-62b4-768d-b762-b8d6461fe3b5.webp",
        "width": 1024,
        "height": 680
      },
      "poi_business_url": "https://theavenuemurfreesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544059927879211805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenue-murfreesboro",
      "poi_latitude": "35.8584298",
      "poi_longitude": "-86.44513959999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-893-4207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOeRiMNn3Y4gRHdtTz22-Dz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4ee29f15e9b0b1a6875ba184",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Stones River Town Centre",
      "poi_type": "Shopping & Retail",
      "poi_address": "1720 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_long_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-4557-74fb-ad43-43046a5b4d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4557-74fb-ad43-43046a5b4d7f",
        "storage_key": "property/5716675206840320/019f14fd-4557-74fb-ad43-43046a5b4d7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.shopstonesriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=106645893605734169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-town-centre",
      "poi_latitude": "35.8480189",
      "poi_longitude": "-86.4175283",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-896-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9_Wm1ff3Y4gRGbcfDeDhegE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7f099699c51995abe999476d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2421 New Salem Hwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-546e-7079-8cec-cd3199d9894f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-546e-7079-8cec-cd3199d9894f",
        "storage_key": "property/5716675206840320/019f14fd-546e-7079-8cec-cd3199d9894f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tn/murfreesboro/30431",
      "poi_directions_map_url": "https://maps.google.com/?cid=3378094415019948139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.8124968",
      "poi_longitude": "-86.4462805",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 629-207-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8duDeQv3Y4gRa7j--Phm4S4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c76bd9dc637feb599dbcbdda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Blackman Elementary School",
      "poi_type": "Education",
      "poi_address": "586 Fortress Blvd, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-4bf3-7528-b70f-e3c2789a416b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4bf3-7528-b70f-e3c2789a416b",
        "storage_key": "property/5716675206840320/019f14fd-4bf3-7528-b70f-e3c2789a416b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://ble.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1496683464515992207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackman-elementary-school",
      "poi_latitude": "35.8537104",
      "poi_longitude": "-86.46654989999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-904-3795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3-LWLy72Y4gRjzqtY65JxRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_adb5a0e9de2caf7ecdd3c92e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Blackman Middle School",
      "poi_type": "Education",
      "poi_address": "3945 Blaze Dr, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-5876-72f6-9860-2972c7ca997c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-5876-72f6-9860-2972c7ca997c",
        "storage_key": "property/5716675206840320/019f14fd-5876-72f6-9860-2972c7ca997c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://blm.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11239179291683413475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackman-middle-school",
      "poi_latitude": "35.8561161",
      "poi_longitude": "-86.4738687",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-904-3860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwlZ-ST2Y4gR4123nwSW-Zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_500e1eaa6e2396f6ef8f3f65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Blackman High School",
      "poi_type": "Education",
      "poi_address": "3956 Blaze Dr, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-59e3-7249-aebb-d7a9d93c9b00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-59e3-7249-aebb-d7a9d93c9b00",
        "storage_key": "property/5716675206840320/019f14fd-59e3-7249-aebb-d7a9d93c9b00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bhs.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15261496130946342664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackman-high-school",
      "poi_latitude": "35.8593111",
      "poi_longitude": "-86.4758157",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-904-3850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5b4jTSH2Y4gRCB8OSt-5y9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_dfcaaa0ae7014c3af91f35a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Overall Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "Overall Creek Elementary, 429 Otter Trl, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.overallcreekelementary.net",
      "poi_directions_map_url": "https://maps.google.com/?cid=5653734318379849051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overall-creek-elementary-school",
      "poi_latitude": "35.8378834",
      "poi_longitude": "-86.4874809",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-624-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90gmyW32Y4gRW1V3ZWgZdk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_12942cbdca6bcd9d0f99df82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Middle Tennessee State University",
      "poi_type": "Education",
      "poi_address": "1301 E Main St, Murfreesboro, TN 37132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-6b7c-7306-b70f-56401e6aed20",
        "storage_key": "property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
        "width": 1158,
        "height": 478
      },
      "poi_business_url": "https://www.mtsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390517612238132658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-state-university",
      "poi_latitude": "35.8486229",
      "poi_longitude": "-86.36691549999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-898-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcKjWZf4Y4gRstWs3B7286s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_064b2a75932f72fe8560de3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Middle Tennessee Christian School",
      "poi_type": "Education",
      "poi_address": "100 E MTCS Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-501b-752d-8679-1ca9edc582a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-501b-752d-8679-1ca9edc582a6",
        "storage_key": "property/5716675206840320/019f14fd-501b-752d-8679-1ca9edc582a6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mtcscougars.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10310611679815471323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-christian-school",
      "poi_latitude": "35.8692068",
      "poi_longitude": "-86.38395009999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-893-0601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTatDzN-cJhUR2xBl4LGmFo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e8853baad86d1882e58fa551",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Fortress Blvd KinderCare",
      "poi_type": "Education",
      "poi_address": "847 Fortress Blvd, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-51a9-7204-8ba6-64a330d28514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-51a9-7204-8ba6-64a330d28514",
        "storage_key": "property/5716675206840320/019f14fd-51a9-7204-8ba6-64a330d28514.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/murfreesboro/tn/086111?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTQ1MDcyOTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17324348902360423407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortress-blvd-kindercare",
      "poi_latitude": "35.8593592",
      "poi_longitude": "-86.46670519999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-203-3669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRbHdECn2Y4gR7xsf0olzbPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4976daa2652f0df595b3e24b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Primrose School of Murfreesboro",
      "poi_type": "Education",
      "poi_address": "554 Brandies Cir, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Daycare with preschool, kindergarten and kindergarten-readiness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-5553-77fd-9ef1-23415712a035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-5553-77fd-9ef1-23415712a035",
        "storage_key": "property/5716675206840320/019f14fd-5553-77fd-9ef1-23415712a035.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/murfreesboro/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2651078364043034502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-murfreesboro",
      "poi_latitude": "35.840551",
      "poi_longitude": "-86.436739",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-848-5301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN8-i-L_3Y4gRhj-C4LmFyiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_f6213acad64afc6dc8460435",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Big Blue Marble Academy Murfreesboro (Veterans Parkway)",
      "poi_type": "Education",
      "poi_address": "5206 Jack Byrnes Dr, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-5cb8-701e-a3c6-13926ca066c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-5cb8-701e-a3c6-13926ca066c2",
        "storage_key": "property/5716675206840320/019f14fd-5cb8-701e-a3c6-13926ca066c2.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://bbmacademy.com/location/veterans-parkway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3985385270289272387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-blue-marble-academy-murfreesboro-veterans-parkway",
      "poi_latitude": "35.8404617",
      "poi_longitude": "-86.49145039999999",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-857-4986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE8sTFBH3Y4gRQ46qsMnuTjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_6300abd570d5619709e96368",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Kiddie Academy of Murfreesboro",
      "poi_type": "Education",
      "poi_address": "5117 Malachite Ln, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-59dc-763a-82fb-00b87cc56942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-59dc-763a-82fb-00b87cc56942",
        "storage_key": "property/5716675206840320/019f14fd-59dc-763a-82fb-00b87cc56942.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/murfreesboro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6519442195325553881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-murfreesboro",
      "poi_latitude": "35.84233930000001",
      "poi_longitude": "-86.48710349999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-956-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI5mn87H3Y4gR2YwSmiK2eVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_c948a18dabbdcb9756326b3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "AMC Stones River 9",
      "poi_type": "Entertainment",
      "poi_address": "1706 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Multiscreen mall cinema screening current films in theaters with reserved, reclining seats.",
      "poi_long_description": "Multiscreen mall cinema screening current films in theaters with reserved, reclining seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-5d88-732f-b6a1-4ae1be784f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-5d88-732f-b6a1-4ae1be784f2d",
        "storage_key": "property/5716675206840320/019f14fd-5d88-732f-b6a1-4ae1be784f2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/nashville-tn/amc-stones-river-9?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10323392328234355477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-stones-river-9",
      "poi_latitude": "35.8479512",
      "poi_longitude": "-86.4179437",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-900-2499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b7f-71e8-8153-27752a3d4d56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b7f-71e8-8153-27752a3d4d56",
        "storage_key": "property/5716675206840320/019f14fd-8b7f-71e8-8153-27752a3d4d56.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJnzso0qf5Y4gRFctmeaAORI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_31984898014391bd9b7a1d67",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Murfreesboro Strike & Spare",
      "poi_type": "Entertainment",
      "poi_address": "1720 Old Fort Pkwy #2002, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Entertainment center with a bowling alley, arcade, bumper cars, Laser Tag and a grill.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-6090-736b-9da8-57b53444faa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-6090-736b-9da8-57b53444faa8",
        "storage_key": "property/5716675206840320/019f14fd-6090-736b-9da8-57b53444faa8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://strikeandspare.com/murfreesboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=9104762392352379325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murfreesboro-strike--spare",
      "poi_latitude": "35.8488643",
      "poi_longitude": "-86.4169907",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxCFOwn4Y4gRvdF_ICidWn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_65f2c5892ec486bcfce4342b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "The Avenue Murfreesboro",
      "poi_type": "Entertainment",
      "poi_address": "2615 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_long_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-62b4-768d-b762-b8d6461fe3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-62b4-768d-b762-b8d6461fe3b5",
        "storage_key": "property/5716675206840320/019f14fa-62b4-768d-b762-b8d6461fe3b5.webp",
        "width": 1024,
        "height": 680
      },
      "poi_business_url": "https://theavenuemurfreesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544059927879211805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenue-murfreesboro",
      "poi_latitude": "35.8584298",
      "poi_longitude": "-86.44513959999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-893-4207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOeRiMNn3Y4gRHdtTz22-Dz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_2a55cf600f9c602e1b239b88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Stones River National Battlefield",
      "poi_type": "Entertainment",
      "poi_address": "3501 Old Nashville Hwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Historic 570-acre park & cemetery with a visitor center & marked trails along Civil War battlefield.",
      "poi_long_description": "Historic 570-acre park & cemetery with a visitor center & marked trails along Civil War battlefield.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-65b0-725a-b57b-78337ab2b287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-65b0-725a-b57b-78337ab2b287",
        "storage_key": "property/5716675206840320/019f14fd-65b0-725a-b57b-78337ab2b287.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/stri",
      "poi_directions_map_url": "https://maps.google.com/?cid=971211896203222545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-national-battlefield",
      "poi_latitude": "35.8760842",
      "poi_longitude": "-86.43078349999999",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-893-9501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b93a-736e-9f28-eeab429d64c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b93a-736e-9f28-eeab429d64c1",
        "storage_key": "property/5716675206840320/019f14fa-b93a-736e-9f28-eeab429d64c1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTHDowQIZIgREZ7T6hJweg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2778aab2c176a93ade75918f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Cannonsburgh Village",
      "poi_type": "Entertainment",
      "poi_address": "312 S Front St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_long_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-614a-7269-89b2-6c2b4312cfa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-614a-7269-89b2-6c2b4312cfa9",
        "storage_key": "property/5716675206840320/019f14fd-614a-7269-89b2-6c2b4312cfa9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/164/Cannonsburgh-Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297667892875141264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannonsburgh-village",
      "poi_latitude": "35.8438439",
      "poi_longitude": "-86.3961824",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-890-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8d4-766d-89d1-f1d3db3660f4",
        "storage_key": "property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVF-ZWv4Y4gRkKBstS1ipDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_1fdd86ff69cef64204682a8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Oaklands Mansion",
      "poi_type": "Entertainment",
      "poi_address": "900 N Maney Ave, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_long_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-74da-77be-b9b9-2391be20378d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-74da-77be-b9b9-2391be20378d",
        "storage_key": "property/5716675206840320/019f14fa-74da-77be-b9b9-2391be20378d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.oaklandsmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14783141961739895160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oaklands-mansion",
      "poi_latitude": "35.856013",
      "poi_longitude": "-86.3850431",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-893-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8d4-766d-89d1-f1d3db3660f4",
        "storage_key": "property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9O2ZHn4Y4gReIGtLUpFKM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_b988296332a0fc6757ffcfa7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Hank's Honky Tonk",
      "poi_type": "Entertainment",
      "poi_address": "2341 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Casual bar and grill serving up comfort food and featuring live music 7 nights a week.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-6d65-76e5-be45-2620f18eab42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-6d65-76e5-be45-2620f18eab42",
        "storage_key": "property/5716675206840320/019f14fd-6d65-76e5-be45-2620f18eab42.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hankshonkytonk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2308537668232701803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hanks-honky-tonk",
      "poi_latitude": "35.8870824",
      "poi_longitude": "-86.3840722",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 615-410-7747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b90-712b-9426-9c3e2e21150f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b90-712b-9426-9c3e2e21150f",
        "storage_key": "property/5716675206840320/019f14fd-8b90-712b-9426-9c3e2e21150f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85ph6aMHZIgRa2eeMceSCSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_9c641556e89479f4337c940b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Tucker Theatre",
      "poi_type": "Entertainment",
      "poi_address": "Murfreesboro, TN 37130, USA",
      "poi_short_description": "Comfortable theatre showcasing dance competitions and putting on plays and other shows.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-667a-73ec-b871-cbafbcada252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-667a-73ec-b871-cbafbcada252",
        "storage_key": "property/5716675206840320/019f14fd-667a-73ec-b871-cbafbcada252.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mtsu.edu/tuckertheatre/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=14677739301971514970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tucker-theatre",
      "poi_latitude": "35.8498131",
      "poi_longitude": "-86.3662659",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-898-2640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeSkg5r4Y4gRWlbNDyHOscs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_44cecb0bbc89035e2cf2b347",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Rutherford County Courthouse",
      "poi_type": "Entertainment",
      "poi_address": "S Public Square, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-66cb-738a-8321-65099f15f2c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-66cb-738a-8321-65099f15f2c3",
        "storage_key": "property/5716675206840320/019f14fd-66cb-738a-8321-65099f15f2c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rutherfordcountytn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18142830710514575470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutherford-county-courthouse",
      "poi_latitude": "35.8460138",
      "poi_longitude": "-86.39201419999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-898-7831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e6-77fa-8439-8d1522e867bb",
        "storage_key": "property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQb2jdfUJZIgRbuhECGhIyPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_8bad71b901de256267377de5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Center For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "110 W College St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Community venue & art gallery hosting exhibits, music, dance & theatrical events in a 1909 building.",
      "poi_long_description": "Community venue & art gallery hosting exhibits, music, dance & theatrical events in a 1909 building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-66ce-766d-ad5b-21d466a42e75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-66ce-766d-ad5b-21d466a42e75",
        "storage_key": "property/5716675206840320/019f14fd-66ce-766d-ad5b-21d466a42e75.webp",
        "width": 700,
        "height": 400
      },
      "poi_business_url": "http://www.boroarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344868861526606933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-the-arts",
      "poi_latitude": "35.8471707",
      "poi_longitude": "-86.3915808",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-904-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzRR9274Y4gRVQTHqBrvqRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_db83e6537f56d98aba3f9ed7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Rutherford",
      "poi_type": "Health and Wellness",
      "poi_address": "1700 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-7ead-72fb-86e3-948b50e56e07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-7ead-72fb-86e3-948b50e56e07",
        "storage_key": "property/5716675206840320/019f14fa-7ead-72fb-86e3-948b50e56e07.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/tennessee/tnnas/murfreesboro-ascension-saint-thomas-rutherford?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1168771784860846153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-rutherford",
      "poi_latitude": "35.8609519",
      "poi_longitude": "-86.4248844",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-396-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8f2-76c8-9a35-1aa5af820a5a",
        "storage_key": "property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRorwbrHxokRSUgh9L5POBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_5f8446018f501de9a8a87e8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Murfreesboro Medical Center Parkway",
      "poi_type": "Health and Wellness",
      "poi_address": "3031 Medical Center Pkwy Ste B, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-6eaa-73ec-b414-bd2efd03c2e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-6eaa-73ec-b414-bd2efd03c2e2",
        "storage_key": "property/5716675206840320/019f14fd-6eaa-73ec-b414-bd2efd03c2e2.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.carenow.com/locations/nashville/medical-center-murfreesboro?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5033171971028789283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---murfreesboro-medical-center-parkway",
      "poi_latitude": "35.8661131",
      "poi_longitude": "-86.4503143",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-846-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_gE2SsIZIgRI6ifoj1r2UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a64e175d205e88011e972735",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Urgent Care - Murfreesboro West",
      "poi_type": "Health and Wellness",
      "poi_address": "1144 Fortress Blvd K, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7035-7488-b677-2341c49620dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7035-7488-b677-2341c49620dd",
        "storage_key": "property/5716675206840320/019f14fd-7035-7488-b677-2341c49620dd.webp",
        "width": 985,
        "height": 688
      },
      "poi_business_url": "https://www.urgentteam.com/locations/ascension-saint-thomas-west-murfreesboro-tn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9064725149700878389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-urgent-care---murfreesboro-west",
      "poi_latitude": "35.8653502",
      "poi_longitude": "-86.4634363",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-809-3541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ880f4CQJZIgRNXB4Jn9fzH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_6a4d8d47d0cb4e2e0e588a01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "The Little Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4432 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-70f3-777f-90df-116f49fea4df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-70f3-777f-90df-116f49fea4df",
        "storage_key": "property/5716675206840320/019f14fd-70f3-777f-90df-116f49fea4df.webp",
        "width": 600,
        "height": 338
      },
      "poi_business_url": "https://www.kroger.com/health-services/clinic/details/855/00123?cid=loc_85500123_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982696180926544069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-little-clinic",
      "poi_latitude": "35.8443295",
      "poi_longitude": "-86.4918462",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-648-8505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYwA8wz2Y4gRxXgKoV-qZCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_6791733cf3e5b3709b62af1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4432 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-71b9-764e-84b4-cacde63712f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-71b9-764e-84b4-cacde63712f6",
        "storage_key": "property/5716675206840320/019f14fd-71b9-764e-84b4-cacde63712f6.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/026/00565?cid=loc_02600565P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15061651814614124473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "35.8434005",
      "poi_longitude": "-86.4418256",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-648-8501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b9e-742b-886b-a9608c1d6159.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b9e-742b-886b-a9608c1d6159",
        "storage_key": "property/5716675206840320/019f14fd-8b9e-742b-886b-a9608c1d6159.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_Qg_MD3Y4gRuUexfIa8BdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e80f3f49b7db2325b4e65e5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Old Fort Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7239-7618-8e7f-262630aeacf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7239-7618-8e7f-262630aeacf8",
        "storage_key": "property/5716675206840320/019f14fd-7239-7618-8e7f-262630aeacf8.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2401+old+fort+pkwy-murfreesboro-tn-37128/id=6277",
      "poi_directions_map_url": "https://maps.google.com/?cid=13523852271583788335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "35.8455676",
      "poi_longitude": "-86.4410549",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-848-0968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b9e-742b-886b-a9608c1d6159.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b9e-742b-886b-a9608c1d6159",
        "storage_key": "property/5716675206840320/019f14fd-8b9e-742b-886b-a9608c1d6159.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9gLkMH3Y4gRL32cEv1frrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_40ca2f7e9dc7d9ed3c436703",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1954 Old Fort Pkwy Ste 6, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Chain fitness center offering a variety of workout equipment, plus tanning and massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-75a4-70c9-b1e0-cbdb76839993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-75a4-70c9-b1e0-cbdb76839993",
        "storage_key": "property/5716675206840320/019f14fa-75a4-70c9-b1e0-cbdb76839993.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/murfreesboro-tn?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9795464346535602539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.849049",
      "poi_longitude": "-86.4246904",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-801-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXGO7fD3Y4gRaylCsex68Ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_300ef07ac5e2f443e24f0624",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2615 Medical Center Pkwy #1730, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Fitness center, chain and studio providing heart rate-based training, plus cardio, strength training and a treadmill.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-799d-772e-9dae-2eded7c5ae90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-799d-772e-9dae-2eded7c5ae90",
        "storage_key": "property/5716675206840320/019f14fd-799d-772e-9dae-2eded7c5ae90.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/murfreesboro-tennessee-0155?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=7005133219268137974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.8574647",
      "poi_longitude": "-86.4430258",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-546-0255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcCYoN73Y4gR9hPEUow7N2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ebe167ddfa6bd1b95c5a1ddc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "3266 Memorial Blvd Ste D, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7296-753f-87c0-4da51efb9202.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7296-753f-87c0-4da51efb9202",
        "storage_key": "property/5716675206840320/019f14fd-7296-753f-87c0-4da51efb9202.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/murfreesboro/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14944640978331424962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "35.9054301",
      "poi_longitude": "-86.38309799999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 615-691-4699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuTDv91cHZIgRwtgwKcoHZs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2389865039a8cb0d31f4e260",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "UrgiKids Pediatric Urgent Care (formerly PM Pediatric Care)",
      "poi_type": "Health and Wellness",
      "poi_address": "2249 Medical Center Pkwy Ste C & D, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7426-741d-a00d-809eade47229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7426-741d-a00d-809eade47229",
        "storage_key": "property/5716675206840320/019f14fd-7426-741d-a00d-809eade47229.webp",
        "width": 780,
        "height": 780
      },
      "poi_business_url": "https://www.urgikids.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3873198194603556973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgikids-pediatric-urgent-care-formerly-pm-pediatric-care",
      "poi_latitude": "35.8573493",
      "poi_longitude": "-86.4364547",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 629-219-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlx79syD3Y4gRbYAHpjxdwDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_db6cda7fe9aeaedaaba51913",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Barfield Crescent Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "697 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Leafy community park with hiking trails, sports fields, a golf course & campsites over 430 acres.",
      "poi_long_description": "Leafy community park with hiking trails, sports fields, a golf course & campsites over 430 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-9a10-763d-a6f3-a3e80672d177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9a10-763d-a6f3-a3e80672d177",
        "storage_key": "property/5716675206840320/019f14fa-9a10-763d-a6f3-a3e80672d177.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.murfreesborotn.gov/181/Barfield-Crescent-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7820963255541423215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barfield-crescent-park",
      "poi_latitude": "35.78400420000001",
      "poi_longitude": "-86.4139969",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b93a-736e-9f28-eeab429d64c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b93a-736e-9f28-eeab429d64c1",
        "storage_key": "property/5716675206840320/019f14fa-b93a-736e-9f28-eeab429d64c1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWLqJ-P5Y4gRb9ztx6SkiWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c9418abab13de66055f78130",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Thompson Lane Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2240 N Thompson Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Park with a waterside trail system for cycling, hiking and dog walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-780d-77ad-aa02-d6f37cce8dbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-780d-77ad-aa02-d6f37cce8dbb",
        "storage_key": "property/5716675206840320/019f14fd-780d-77ad-aa02-d6f37cce8dbb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.murfreesborotn.gov/Facilities/Facility/Details/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=7254035923734982804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thompson-lane-trailhead",
      "poi_latitude": "35.8871478",
      "poi_longitude": "-86.42275459999999",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSFpZnQIZIgRlHAlNj2Dq2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_b5260f81268978c7cd366a51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Broad Street Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1921 NW Broad St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7a69-734b-86de-f5ed3ca86a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7a69-734b-86de-f5ed3ca86a5c",
        "storage_key": "property/5716675206840320/019f14fd-7a69-734b-86de-f5ed3ca86a5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.murfreesborotn.gov/index.aspx?NID=185",
      "poi_directions_map_url": "https://maps.google.com/?cid=13617409743876391325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broad-street-trailhead",
      "poi_latitude": "35.8750303",
      "poi_longitude": "-86.4233514",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfQwzggIZIgRnQGykAPC-rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_270369dbb4ccf332010e43fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Old Fort Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1028 Golf Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Public golf course where many play from the cart paths and golfers can rent clubs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-9633-7186-ae62-838a6162c493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9633-7186-ae62-838a6162c493",
        "storage_key": "property/5716675206840320/019f14fa-9633-7186-ae62-838a6162c493.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.oldfortgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14881041515042474679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-fort-golf-course",
      "poi_latitude": "35.853665",
      "poi_longitude": "-86.415588",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-896-2448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-be63-7522-b32f-fc80292aef19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-be63-7522-b32f-fc80292aef19",
        "storage_key": "property/5716675206840320/019f14fa-be63-7522-b32f-fc80292aef19.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZwlB_j3Y4gRt4ryL2oUhM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_ebe6ade7743d7675bd90d0d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Cannonsburgh Village",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 S Front St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_long_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-614a-7269-89b2-6c2b4312cfa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-614a-7269-89b2-6c2b4312cfa9",
        "storage_key": "property/5716675206840320/019f14fd-614a-7269-89b2-6c2b4312cfa9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/164/Cannonsburgh-Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297667892875141264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannonsburgh-village",
      "poi_latitude": "35.8438439",
      "poi_longitude": "-86.3961824",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-890-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8d4-766d-89d1-f1d3db3660f4",
        "storage_key": "property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVF-ZWv4Y4gRkKBstS1ipDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_8ce262ab5a80cce4450dfd68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Discovery Center at Murfree Spring",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "502 SE Broad St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Interactive kids' museum with exhibits on science & culture plus live animals & outdoor programs.",
      "poi_long_description": "Interactive kids' museum with exhibits on science & culture plus live animals & outdoor programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-6eb8-70eb-b924-44012b052519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-6eb8-70eb-b924-44012b052519",
        "storage_key": "property/5716675206840320/019f14fa-6eb8-70eb-b924-44012b052519.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://explorethedc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619293887475863846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-center-at-murfree-spring",
      "poi_latitude": "35.8387545",
      "poi_longitude": "-86.3870876",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-890-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8d4-766d-89d1-f1d3db3660f4",
        "storage_key": "property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxvj-Wf4Y4gRJtFtPQnhwtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_1cd081a958e9d2aaa800a792",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Oaklands Mansion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 N Maney Ave, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_long_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-74da-77be-b9b9-2391be20378d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-74da-77be-b9b9-2391be20378d",
        "storage_key": "property/5716675206840320/019f14fa-74da-77be-b9b9-2391be20378d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.oaklandsmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14783141961739895160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oaklands-mansion",
      "poi_latitude": "35.856013",
      "poi_longitude": "-86.3850431",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-893-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8d4-766d-89d1-f1d3db3660f4",
        "storage_key": "property/5716675206840320/019f14fa-b8d4-766d-89d1-f1d3db3660f4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9O2ZHn4Y4gReIGtLUpFKM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_7f0af319404e9d58cfe973f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Richard Siegel Soccer Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "515 Cherry Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Popular complex showcasing grassy and artificial-turf fields as well as an indoor venue for games and events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-79eb-764f-a609-9d51fa05304c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-79eb-764f-a609-9d51fa05304c",
        "storage_key": "property/5716675206840320/019f14fd-79eb-764f-a609-9d51fa05304c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.murfreesborotn.gov/194/Siegel-Soccer-Complex-Community-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14945898256824574208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richard-siegel-soccer-complex",
      "poi_latitude": "35.9240809",
      "poi_longitude": "-86.3869237",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 615-801-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTVll0IGZIgRAKEoH0d_as8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_c2a9b0f86d3e20a5c1fc7c71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Patterson Park Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "521 Dr. Martin Luther King Jr. Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Family-oriented recreation space with a water park, an indoor pool and a library.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7686-7478-855c-08a5cf3d05aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7686-7478-855c-08a5cf3d05aa",
        "storage_key": "property/5716675206840320/019f14fd-7686-7478-855c-08a5cf3d05aa.webp",
        "width": 1280,
        "height": 495
      },
      "poi_business_url": "https://www.murfreesborotn.gov/168/Patterson-Park-Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4923743624017934486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patterson-park-community-center",
      "poi_latitude": "35.8391816",
      "poi_longitude": "-86.3822323",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-893-7439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl4IxbF74Y4gRlviuKr2mVEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_d93fe3def282057782180072",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Murfreesboro Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "324 New Salem Hwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8845098556559688270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murfreesboro-transit-center",
      "poi_latitude": "35.8415655",
      "poi_longitude": "-86.4092474",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmY1acQD5Y4gRToIPG0YawHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_8e3c4dae25a53766cf317199",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Old Fort Golf Course",
      "poi_type": "Transportation & Transit",
      "poi_address": "1028 Golf Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Public golf course where many play from the cart paths and golfers can rent clubs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-9633-7186-ae62-838a6162c493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9633-7186-ae62-838a6162c493",
        "storage_key": "property/5716675206840320/019f14fa-9633-7186-ae62-838a6162c493.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.oldfortgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14881041515042474679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-fort-golf-course",
      "poi_latitude": "35.853665",
      "poi_longitude": "-86.415588",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-896-2448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-be63-7522-b32f-fc80292aef19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-be63-7522-b32f-fc80292aef19",
        "storage_key": "property/5716675206840320/019f14fa-be63-7522-b32f-fc80292aef19.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZwlB_j3Y4gRt4ryL2oUhM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_de4623309806f259e8214a43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Stones River Town Centre",
      "poi_type": "Transportation & Transit",
      "poi_address": "1720 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_long_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-4557-74fb-ad43-43046a5b4d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4557-74fb-ad43-43046a5b4d7f",
        "storage_key": "property/5716675206840320/019f14fd-4557-74fb-ad43-43046a5b4d7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.shopstonesriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=106645893605734169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-town-centre",
      "poi_latitude": "35.8480189",
      "poi_longitude": "-86.4175283",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-896-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b875-73bd-8336-190a46ad8322",
        "storage_key": "property/5716675206840320/019f14fa-b875-73bd-8336-190a46ad8322.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9_Wm1ff3Y4gRGbcfDeDhegE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_bb520271520871fae0a405af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Middle Tennessee State University",
      "poi_type": "Transportation & Transit",
      "poi_address": "1301 E Main St, Murfreesboro, TN 37132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-6b7c-7306-b70f-56401e6aed20",
        "storage_key": "property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
        "width": 1158,
        "height": 478
      },
      "poi_business_url": "https://www.mtsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390517612238132658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-state-university",
      "poi_latitude": "35.8486229",
      "poi_longitude": "-86.36691549999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-898-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcKjWZf4Y4gRstWs3B7286s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_47e18c86e2d365773c53a888",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "North Boulevard Church of Christ - East Murfreesboro",
      "poi_type": "Transportation & Transit",
      "poi_address": "1112 N Rutherford Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7879-767b-aaeb-415efebfdd99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7879-767b-aaeb-415efebfdd99",
        "storage_key": "property/5716675206840320/019f14fd-7879-767b-aaeb-415efebfdd99.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://northboulevard.com/east",
      "poi_directions_map_url": "https://maps.google.com/?cid=9679464143618113918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-boulevard-church-of-christ---east-murfreesboro",
      "poi_latitude": "35.8611864",
      "poi_longitude": "-86.3510728",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-893-1520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b9c-75cc-9b31-747d78071be4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b9c-75cc-9b31-747d78071be4",
        "storage_key": "property/5716675206840320/019f14fd-8b9c-75cc-9b31-747d78071be4.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJl70gAKT4Y4gRfgF9yFpdVIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_c5276afa13c6ef30352f46a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "City of Murfreesboro Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1930 Memorial Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7e36-72ba-8194-fbf08ef888f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7e36-72ba-8194-fbf08ef888f9",
        "storage_key": "property/5716675206840320/019f14fd-7e36-72ba-8194-fbf08ef888f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/95/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=7109091869414085853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-murfreesboro-airport",
      "poi_latitude": "35.876983",
      "poi_longitude": "-86.3807137",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-848-3254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b79-7299-af81-7bdb9da9c1ca",
        "storage_key": "property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ850w35sHZIgR3VQLwGORqGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_bd85a57ddf9e7be37a35b80e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Smyrna/Rutherford County Airport Authority",
      "poi_type": "Transportation & Transit",
      "poi_address": "278 Doug Warpoole Rd, Smyrna, TN 37167, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7d14-7311-bb19-764aa4794b64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7d14-7311-bb19-764aa4794b64",
        "storage_key": "property/5716675206840320/019f14fd-7d14-7311-bb19-764aa4794b64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.smyrnaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5204850400209566384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smyrnarutherford-county-airport-authority",
      "poi_latitude": "36.004326",
      "poi_longitude": "-86.52589499999999",
      "poi_miles_from_property": "19.3 mi",
      "poi_walking_minutes": "7 hours 2 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 615-459-2651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b79-7299-af81-7bdb9da9c1ca",
        "storage_key": "property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVJw3LANZIgRsHqKzdxXO0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_5ca3cbf067707d2bd2e8e2fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Nashville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-7cb2-719e-8924-fbe0061bdcb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-7cb2-719e-8924-fbe0061bdcb0",
        "storage_key": "property/5716675206840320/019f14fd-7cb2-719e-8924-fbe0061bdcb0.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "30.4 mi",
      "poi_walking_minutes": "11 hours 9 mins",
      "poi_biking_minutes": "2 hours 50 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b79-7299-af81-7bdb9da9c1ca",
        "storage_key": "property/5716675206840320/019f14fd-8b79-7299-af81-7bdb9da9c1ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_9f4143e37b182e9454ff9fac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 W Main St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-81d0-77c0-a1df-3692259efb6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-81d0-77c0-a1df-3692259efb6f",
        "storage_key": "property/5716675206840320/019f14fd-81d0-77c0-a1df-3692259efb6f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-400609",
      "poi_directions_map_url": "https://maps.google.com/?cid=14278922801362826142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "35.8469066",
      "poi_longitude": "-86.3991106",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-78ORP4Y4gRnvN0hqLsKMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_44184020ec5da617de01c374",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Transportation & Transit",
      "poi_address": "5265 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-4351-76b2-b9f8-0bb80a811f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4351-76b2-b9f8-0bb80a811f65",
        "storage_key": "property/5716675206840320/019f14fd-4351-76b2-b9f8-0bb80a811f65.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tn/murfreesboro/5265-veterans-pkwy-41962?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216769757779209066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.8620114",
      "poi_longitude": "-86.50866239999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 629-267-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8b7f-71e8-8153-2a9d8361b618.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-8b7f-71e8-8153-2a9d8361b618",
        "storage_key": "property/5716675206840320/019f14fd-8b7f-71e8-8153-2a9d8361b618.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbyimKAD1Y4gRaivSJihnRlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_4dc195ee06d94e43f8de8143",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Rutherford",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-7ead-72fb-86e3-948b50e56e07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-7ead-72fb-86e3-948b50e56e07",
        "storage_key": "property/5716675206840320/019f14fa-7ead-72fb-86e3-948b50e56e07.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/tennessee/tnnas/murfreesboro-ascension-saint-thomas-rutherford?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1168771784860846153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-rutherford",
      "poi_latitude": "35.8609519",
      "poi_longitude": "-86.4248844",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-396-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8f2-76c8-9a35-1aa5af820a5a",
        "storage_key": "property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRorwbrHxokRSUgh9L5POBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_5fd819a8e0267b90d12b3806",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Middle Tennessee State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 E Main St, Murfreesboro, TN 37132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-6b7c-7306-b70f-56401e6aed20",
        "storage_key": "property/5716675206840320/019f14fa-6b7c-7306-b70f-56401e6aed20.webp",
        "width": 1158,
        "height": 478
      },
      "poi_business_url": "https://www.mtsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390517612238132658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-state-university",
      "poi_latitude": "35.8486229",
      "poi_longitude": "-86.36691549999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-898-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcKjWZf4Y4gRstWs3B7286s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_bdec70de592657cab1d08445",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Rutherford County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "S Public Square, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-66cb-738a-8321-65099f15f2c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-66cb-738a-8321-65099f15f2c3",
        "storage_key": "property/5716675206840320/019f14fd-66cb-738a-8321-65099f15f2c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rutherfordcountytn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18142830710514575470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutherford-county-courthouse",
      "poi_latitude": "35.8460138",
      "poi_longitude": "-86.39201419999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-898-7831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e6-77fa-8439-8d1522e867bb",
        "storage_key": "property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQb2jdfUJZIgRbuhECGhIyPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_b45548fde70f34b7105f5cda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "City of Murfreesboro - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 W Vine St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-8d26-74de-81e7-0ccd8daf0fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8d26-74de-81e7-0ccd8daf0fae",
        "storage_key": "property/5716675206840320/019f14fa-8d26-74de-81e7-0ccd8daf0fae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.murfreesborotn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11339899403198497773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-murfreesboro---city-hall",
      "poi_latitude": "35.8441278",
      "poi_longitude": "-86.392957",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-893-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e6-77fa-8439-8d1522e867bb",
        "storage_key": "property/5716675206840320/019f14fa-b8e6-77fa-8439-8d1522e867bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwvbWWn4Y4gR7YNPBG1qX50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_94e40d0d72979927c80b998d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "National Healthcare Corportation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Vine St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-a4f7-7600-8c2e-71be1d2ad528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a4f7-7600-8c2e-71be1d2ad528",
        "storage_key": "property/5716675206840320/019f14fa-a4f7-7600-8c2e-71be1d2ad528.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.nhccare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5944028850158996745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-healthcare-corportation",
      "poi_latitude": "35.8446088",
      "poi_longitude": "-86.39127859999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-890-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOStPzW74Y4gRCY1mFL9ufVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_0a30504ef4de99604c52cb18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "BNA3 Amazon Fulfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2020 Joe B Jackson Pkwy, Murfreesboro, TN 37127, USA",
      "poi_short_description": "Chain facility primarily categorized as a warehouse.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-84fc-768e-8bed-601a0aadc1fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-84fc-768e-8bed-601a0aadc1fd",
        "storage_key": "property/5716675206840320/019f14fd-84fc-768e-8bed-601a0aadc1fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4818390984801170569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bna3-amazon-fulfillment-center",
      "poi_latitude": "35.7777708",
      "poi_longitude": "-86.3635086",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 866-216-1072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQvCOXj5Y4gRibQEXhJd3kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_5de87699d6cbc04f53be3d9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Nissan Smyrna Assembly Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "983 Nissan Dr, Smyrna, TN 37167, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8497-720f-b239-29c749da37e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-8497-720f-b239-29c749da37e8",
        "storage_key": "property/5716675206840320/019f14fd-8497-720f-b239-29c749da37e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nissan-smyrna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631528119583190735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nissan-smyrna-assembly-plant",
      "poi_latitude": "35.9640439",
      "poi_longitude": "-86.4930116",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 615-459-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt3mxQKUOZIgRzy6tB7UOz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_639d6b37c28e596e029fc4a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Ingram Content Group LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Ingram Blvd, La Vergne, TN 37086, USA",
      "poi_short_description": "Distribution service and book publisher also acting as a point of interest.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-8546-769d-bb42-ccfb5668852b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-8546-769d-bb42-ccfb5668852b",
        "storage_key": "property/5716675206840320/019f14fd-8546-769d-bb42-ccfb5668852b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ingramcontent.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8322979339321512268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-content-group-llc",
      "poi_latitude": "35.996985",
      "poi_longitude": "-86.5893076",
      "poi_miles_from_property": "21.5 mi",
      "poi_walking_minutes": "7 hours 53 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 615-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8e7-705a-bf1e-2034c361c968",
        "storage_key": "property/5716675206840320/019f14fa-b8e7-705a-bf1e-2034c361c968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3H5xNdyZIgRTJEssZwpgXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_198783c336fca464f5760c40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "Rutherford County Board of Education",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2240 Southpark Dr, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8907406498491847688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutherford-county-board-of-education",
      "poi_latitude": "35.8131942",
      "poi_longitude": "-86.4021604",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-893-5812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b885-71a2-84d0-34fc1995588d",
        "storage_key": "property/5716675206840320/019f14fa-b885-71a2-84d0-34fc1995588d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSkuWMn5Y4gRCNScVAR3nXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_b09d723b171af002f53d55aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "poi_name": "TriStar StoneCrest Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 StoneCrest Boulevard, Smyrna, TN 37167, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fd-84de-704d-8c15-db0c923bafc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-84de-704d-8c15-db0c923bafc1",
        "storage_key": "property/5716675206840320/019f14fd-84de-704d-8c15-db0c923bafc1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tristarhealth.com/locations/tristar-stonecrest-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18134541810091118572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tristar-stonecrest-medical-center",
      "poi_latitude": "35.9753508",
      "poi_longitude": "-86.56511909999999",
      "poi_miles_from_property": "19.3 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 615-768-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-b8f2-76c8-9a35-1aa5af820a5a",
        "storage_key": "property/5716675206840320/019f14fa-b8f2-76c8-9a35-1aa5af820a5a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0MLqrgMZIgR7E_zArLVqvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a4f765a8-e47b-4291-aef8-996272d1cb6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9155bd10-64de-4776-bfc9-44476472bd1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a0758046-1a9f-46ff-a9be-228b86ac87ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e981197b-0e75-4277-87a7-6b429ed8d730",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a3394f4c-64da-44b6-97b7-6a0c0eab55ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4d727da3-d067-42ff-b599-b8a934d3b36c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1bd0bc4e8611281e279db3d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "rating": "5",
      "name": "false",
      "text": "Cute little floorplans that feel cozy with all the trees. Really like the private entrances. Staff is friendly and maintenance is really fast when I put in an issue. Also like that it’s gated. ",
      "date": "false",
      "title": "Cozy Community, Friendly Staff"
    },
    {
      "id": "ec_4b356ec98f346667fa4a9c8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "rating": "5",
      "name": "false",
      "text": "The leasing and management team are responsive and genuinely helpful — any maintenance requests I've put in have been handled quickly and professionally.\n\nThe apartment itself is well-maintained and spacious, with nice finishes that make it feel like home. The grounds are always clean and well kept.\n\nOverall, it's a well-run community and I'd recommend it to anyone looking for a place to live in the area.",
      "date": "false",
      "title": "LOVE IT HERE!"
    },
    {
      "id": "ec_e3a1ade70a0550e3c1dfefae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "rating": "5",
      "name": "false",
      "text": "I've really enjoyed my time here. The staffing is kind and helpful with all my questions and maintenance has always been speedy and efficient! I've lived at apartments before where I would go weeks without something fixed and they always get it done ( and done well!) within 2 days, usually same day! An apartment can be a place to live, but the team, amenities, and care they put in make it a home! ",
      "date": "false",
      "title": "Great Team! "
    },
    {
      "id": "ec_7269a451fbdd1a9ec1fed5ef",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "rating": "5",
      "name": "false",
      "text": "Scout Landing is a wonderful place to live! The community is beautiful, well maintained, and in a great location in Murfreesboro. The office staff is always friendly, welcoming, and willing to help whenever you need anything. Maintenance is responsive and does a great job keeping everything taken care of. You can really tell the team cares about the residents and the community. I would definitely recommend Scout Landing to anyone looking for a great place to call home!\n\n",
      "date": "false",
      "title": "Wonderful!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_80cfd15acb2346c9290c5f94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f14c3-aebf-71eb-8871-bf0c0cb142bf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-aebf-71eb-8871-bf0c0cb142bf",
        "storage_key": "property/5716675206840320/019f14c3-aebf-71eb-8871-bf0c0cb142bf.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Scout Landing Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/hYxMkYDmODQ"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-ec26-7700-908e-e740a9e0d8be",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "scout-landing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320"
    },
    {
      "lead_collector_id": "0198aa45-ec88-7349-b1d4-42dee2511217",
      "lead_source": "FACEBOOK_ADS",
      "name": "scout-landing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320"
    },
    {
      "lead_collector_id": "0198aa45-ecea-7542-8570-dd9b306baf81",
      "lead_source": "LANDING_PAGE",
      "name": "scout-landing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-murfreesboro-tn-scout-landing-373",
      "search_query": "apartments with in-unit laundry Murfreesboro TN",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at our Murfreesboro, TN apartments. Experience hassle-free living at Scout Landing today.",
      "page_copy": "Experience the ultimate convenience at Scout Landing in Murfreesboro, TN, with our apartments that include in-unit laundry! Save time and effort with this sought-after amenity, making laundry day easier than ever before. Choose from our selection of one, two, and three-bedroom floor plans tailored to your lifestyle. \n\nScout Landing not only offers the convenience of in-unit laundry but also boasts other fantastic amenities like a modern fitness center, a dog park for your furry friends, and EV charging stations. Live comfortably and conveniently at our gated community, featuring walk-in closets and cable-ready apartments. Come visit Scout Landing and discover your perfect home in Rutherford County today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry",
      "seo_description": "Discover Murfreesboro apartments with in-unit laundry and more conveniences at Scout Landing. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "scout-landing-pool-apartments-rutherford-county-215",
      "search_query": "Scout Landing pool apartments Rutherford County",
      "category": "Amenity",
      "h1_title": "Scout Landing Pool Apartments",
      "h2_subtitle": "Dive into relaxation at Scout Landing, Rutherford County. Our apartments feature a refreshing swimming pool perfect for any sunny day.",
      "page_copy": "At Scout Landing in Rutherford County, immerse yourself in the comfort and leisure of our pool apartments. Our scenic swimming pool offers you a perfect spot to unwind, whether diving in for a swim or relaxing by the water with a good book.\n\nBeyond our refreshing pool, Scout Landing provides an array of amenities designed to enhance your lifestyle. Enjoy the convenience of a modern fitness center, stay connected with cable-ready units, and effortlessly manage laundry with in-unit laundry facilities. Located in Murfreesboro, TN, Scout Landing is where community and comfort meet. Visit us today to find your dream home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scout Landing Pool Apartments",
      "seo_description": "Enjoy vibrant living at Scout Landing in Rutherford County. Discover poolside leisure and modern amenities in our Murfreesboro community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-murfreesboro-scout-landing-959",
      "search_query": "pet-friendly apartments with dog park Murfreesboro",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Bring your furry friends to our pet-friendly apartments in Murfreesboro. Enjoy our expansive dog park at Scout Landing.",
      "page_copy": "At Scout Landing, we understand that pets are family. That's why we offer pet-friendly apartments complete with a spacious dog park in Murfreesboro, TN. Let your furry companions run and play in a safe and welcoming environment tailored for their enjoyment.\n\nScout Landing not only caters to pet owners but provides a comprehensive living experience with top-notch amenities. Explore our fitness center, take advantage of in-unit laundry facilities, and relish the modern comforts of walk-in closets. Situated in the welcoming community of Rutherford County, Scout Landing is designed with both you and your pets in mind. Schedule a visit today and make the move to a lifestyle that embraces all family members, furry ones included!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly living with a dog park at Scout Landing, Murfreesboro. Ideal for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "scout-landing-air-conditioned-apartments-tennessee-440",
      "search_query": "Scout Landing air conditioned apartments Tennessee",
      "category": "Amenity",
      "h1_title": "Scout Landing Air Conditioned Apartments",
      "h2_subtitle": "Stay cool at Scout Landing, where our Tennessee apartments come with efficient air conditioning. Comfort and convenience await you.",
      "page_copy": "Scout Landing in Murfreesboro, Tennessee, offers air-conditioned apartments that ensure comfort throughout the seasons. Our modern units provide an ideal retreat from the warm Tennessee weather, allowing you to relax and enjoy the climate-controlled environment comfortably.\n\nIn addition to air conditioning, Scout Landing boasts a variety of amenities designed to enhance your living experience. Indulge in our fitness center, or spend time outdoors at our dog park. We also feature in-unit laundry facilities and walk-in closets for added convenience. Located in the heart of Rutherford County, our community is designed to cater to your needs. Visit Scout Landing today and find your perfect home in Tennessee!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scout Landing Air Conditioned Apartments",
      "seo_description": "Explore air-conditioned comfort at Scout Landing in Tennessee. Experience cool living with modern amenities in Murfreesboro.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-37128-scout-landing-830",
      "search_query": "apartments with dishwasher 37128",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in 37128",
      "h2_subtitle": "Discover the convenience of apartments with a dishwasher in the 37128 area. Located at Scout Landing, Murfreesboro's premier community.",
      "page_copy": "Scout Landing offers the perfect blend of convenience and comfort with apartments featuring dishwashers, right in the heart of Murfreesboro's 37128 area. Enjoy the ease of modern living with state-of-the-art kitchen appliances that simplify your daily routines.\n\nNot only do our apartments come equipped with dishwashers, but Scout Landing also boasts a variety of amenities designed to enhance your lifestyle. Take advantage of our fitness center, indulge in the outdoors at the dog park, and enjoy the spaciousness of walk-in closets. Our community in Rutherford County is designed to cater to all your needs, making it the perfect place to call home. Schedule a visit today to experience life at Scout Landing!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in 37128",
      "seo_description": "Find convenience with a dishwasher at Scout Landing. Ideal living in Murfreesboro's 37128 area with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-murfreesboro-tn-scout-landing-276",
      "search_query": "one bedroom apartments murfreesboro tn",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Murfreesboro, TN",
      "h2_subtitle": "Explore stylish one-bedroom apartments at Scout Landing, located in vibrant Murfreesboro, TN. Experience comfort and modern living today.",
      "page_copy": "Scout Landing presents beautifully designed one-bedroom apartments nestled in the welcoming community of Murfreesboro, TN. Perfect for singles and couples, our thoughtfully planned units offer modern amenities and a cozy yet spacious environment that feels like home.\n\nEach one-bedroom apartment is equipped with contemporary features, including energy-efficient appliances and walk-in closets. Residents enjoy access to our full suite of amenities such as the fitness center, outdoor kitchen, and a secure gated community. At Scout Landing, we're committed to providing you with a living experience that blends comfort, convenience, and style. Schedule a tour today and discover why our one-bedroom apartments in Murfreesboro should be your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Murfreesboro, TN",
      "seo_description": "Discover one-bedroom apartments at Scout Landing in Murfreesboro, TN. Enjoy modern amenities and comfort in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "two-bedroom-rentals-rutherford-county-scout-landing-714",
      "search_query": "two bedroom rentals rutherford county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Rutherford County",
      "h2_subtitle": "Experience spacious two-bedroom rentals at Scout Landing, located in the heart of Rutherford County. Modern living with community perks awaits you here.",
      "page_copy": "Scout Landing offers spacious two-bedroom rentals designed with modern living in mind, right here in the thriving heart of Rutherford County. Ideal for small families or roommates, our thoughtfully crafted apartments come with a host of features like energy-efficient appliances and generous walk-in closets.\n\nResidents of our community enjoy access to top-notch amenities, including a fitness center, gated access, and even a delightful outdoor kitchen. Located in Murfreesboro, Scout Landing combines comfort and convenience, making it a perfect choice for those seeking a welcoming community within Rutherford County. Visit us today and see what makes our two-bedroom rentals stand out!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Rutherford County",
      "seo_description": "Find your spacious two-bedroom rental at Scout Landing in Rutherford County. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5716675206840320",
      "source": "custom",
      "page_item_url": "three-bedroom-floor-plans-near-37128-scout-landing-430",
      "search_query": "three bedroom floor plans near 37128",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floor Plans Near 37128",
      "h2_subtitle": "Discover versatile three-bedroom floor plans at Scout Landing, ideally situated near the 37128 area. A perfect blend of style and spaciousness.",
      "page_copy": "Scout Landing invites you to explore our versatile three-bedroom floor plans designed to provide a spacious and inviting living area near the 37128 locale. Perfect for growing families or those needing extra space, our apartments balance style and functionality with finesse.\n\nExperience modern living with features such as smart locks and cable readiness, alongside access to a vibrant community atmosphere. Our three-bedroom apartments come with access to top-tier amenities including a fitness center and EV charging stations, making Scout Landing not just a place to live, but a place to call home. Located conveniently in Murfreesboro, Scout Landing offers unparalleled living in the 37128 area. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room and kitchen with a fireplace, breakfast bar, and dining area.",
        "public_id": "019f6c10-a4d4-70ba-8e10-15a2597b9c64",
        "storage_key": "property/5716675206840320/019f6c10-a4d4-70ba-8e10-15a2597b9c64.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floor Plans Near 37128",
      "seo_description": "Explore spacious three-bedroom floor plans at Scout Landing, located conveniently near the 37128 area, offering modern amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2298"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043838"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a46\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a46\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4975491"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MRTMVTB"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8384315321"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "6bc3911f14f49591"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywyjgrgwq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/61afbc46-8158-49dd-b0df-5ab12ef4f17c"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "629-276-3612"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjVKbnNQSjhuVGhXV0k4dkE5bHY0V1E9PSIsInZhbHVlIjoiZzQwaUZCMXlQNHd0QkE4R1BVbUlPQT09IiwibWFjIjoiMGQ0MmY0MzQzYWI4NjA1ODVhYThjNTRiMGQ5MGIxYTUzZTZiMGRkZjViN2ViM2Q5MGFhNTllZTRkYWIyZThhMiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2298",
  "custom_repli_id": "2505043838",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a46\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a46\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4975491",
  "custom_google_gtm_id": "GTM-MRTMVTB",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8384315321",
  "custom_knock_community_id": "6bc3911f14f49591",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywyjgrgwq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/61afbc46-8158-49dd-b0df-5ab12ef4f17c",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "629-276-3612",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjVKbnNQSjhuVGhXV0k4dkE5bHY0V1E9PSIsInZhbHVlIjoiZzQwaUZCMXlQNHd0QkE4R1BVbUlPQT09IiwibWFjIjoiMGQ0MmY0MzQzYWI4NjA1ODVhYThjNTRiMGQ5MGIxYTUzZTZiMGRkZjViN2ViM2Q5MGFhNTllZTRkYWIyZThhMiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:37:05.011Z';
